//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import hotelId from "HotelId.json";
import hotels from "HotelResponse.json";
import axios from "axios";
import moment from "moment";
export class ApiCredentialsOptions {
  constructor(private agentApiUrl: string, private accessToken: string) { }
  getBaseUrl(defaultUrl?: string) {
    return this.agentApiUrl;
  }

  transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
    let headers: any = options.headers;
    headers["Authorization"] = "Bearer " + this.accessToken;
    if (options.headers && this.accessToken) {
      // (<Headers>options.headers).append('Authorization', 'Bearer ' + this.accessToken);
      options.headers = headers;
    }
    return Promise.resolve(options);
  }
}

export class AgentApiTypeScriptClientBase {
  constructor(private apiCredentialsOptions: ApiCredentialsOptions) { }

  getBaseUrl(token: string, defaultUrl?: string) {
    return this.apiCredentialsOptions
      ? this.apiCredentialsOptions.getBaseUrl(defaultUrl)
      : defaultUrl!;
  }

  transformOptions(options: RequestInit): Promise<RequestInit> {
    return this.apiCredentialsOptions
      ? this.apiCredentialsOptions.transformHttpRequestOptions(options)
      : Promise.resolve(options);
  }
}

//---------- Hotel API -------------
export class ApiHotelCredentialsOptions {
  constructor(private AgentHotelUrl: string, private accessToken: string) { }
  getHotelBaseUrl(defaultUrl?: string) {
    return this.AgentHotelUrl;
  }
  transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
    let headers: any = options.headers;
    headers["Authorization"] = "Bearer " + this.accessToken;
    if (options.headers && this.accessToken) {
      // (<Headers>options.headers).append('Authorization', 'Bearer ' + this.accessToken);
      options.headers = headers;
    }
    return Promise.resolve(options);
  }
}

// Hotel TypeScript
export class AgentApiHotelTypeScriptClientBase {
  constructor(private apiCredentialsOptions: ApiHotelCredentialsOptions) { }

  getHotelBaseUrl(token: string, defaultUrl?: string) {
    return this.apiCredentialsOptions
      ? this.apiCredentialsOptions.getHotelBaseUrl(defaultUrl)
      : defaultUrl!;
  }

  transformOptions(options: RequestInit): Promise<RequestInit> {
    return this.apiCredentialsOptions
      ? this.apiCredentialsOptions.transformHttpRequestOptions(options)
      : Promise.resolve(options);
  }
}

export interface IAuthorizedServicesClient {
  getBookingManagerFilterOptions(
    request: BookingManagerFilterOptionsRequest
  ): Promise<BookingManagerFilterOptionsResponse>;
  refreshToken(): Promise<LoginResult>;
  getFapiLogin(): Promise<FapiLoginSettingsModel>;
}

export class AuthorizedServicesClient
  extends AgentApiTypeScriptClientBase
  implements IAuthorizedServicesClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getBookingManagerFilterOptions(
    request: BookingManagerFilterOptionsRequest,
    signal?: AbortSignal | undefined
  ): Promise<BookingManagerFilterOptionsResponse> {
    let url_ =
      this.baseUrl + "/authorizedservices/getbookingmanagerfilteroptions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBookingManagerFilterOptions(_response);
      });
  }

  protected processGetBookingManagerFilterOptions(
    response: Response
  ): Promise<BookingManagerFilterOptionsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingManagerFilterOptionsResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingManagerFilterOptionsResponse>(null as any);
  }

  refreshToken(signal?: AbortSignal | undefined): Promise<LoginResult> {
    let url_ = this.baseUrl + "/authorizedservices/refreshtoken";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRefreshToken(_response);
      });
  }

  protected processRefreshToken(response: Response): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  getFapiLogin(
    signal?: AbortSignal | undefined
  ): Promise<FapiLoginSettingsModel> {
    let url_ = this.baseUrl + "/authorizedservices/getfapilogin";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFapiLogin(_response);
      });
  }

  protected processGetFapiLogin(
    response: Response
  ): Promise<FapiLoginSettingsModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as FapiLoginSettingsModel);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FapiLoginSettingsModel>(null as any);
  }
}

export interface IInfoClient {
  getVersion(): Promise<VersionInformationModel>;

  /**
   * Returns a list of Release infos ordered by date.
   * @param environment (optional) If left empty, returns release notes for the current environment. Valid values are "development","staging" and "production"
   * @param skip (optional) Skips results
   * @param amount (optional) Specifies the amount of returned release notes. Defaults to 5
   */
  getReleaseInfos(
    environment: string | null | undefined,
    skip: number | null | undefined,
    amount: number | null | undefined
  ): Promise<ReleaseVersionInfo[]>;

  sendSignupMail(email: string | null): Promise<void>;

  confirmSignupMail(code: string | null): Promise<string>;

  unsubscribe(code: string | null): Promise<string>;
}

export class InfoClient
  extends AgentApiTypeScriptClientBase
  implements IInfoClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getVersion(
    signal?: AbortSignal | undefined
  ): Promise<VersionInformationModel> {
    let url_ = this.baseUrl + "/Info/GetVersion";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetVersion(_response);
      });
  }

  protected processGetVersion(
    response: Response
  ): Promise<VersionInformationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as VersionInformationModel);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VersionInformationModel>(null as any);
  }

  /**
   * Returns a list of Release infos ordered by date.
   * @param environment (optional) If left empty, returns release notes for the current environment. Valid values are "development","staging" and "production"
   * @param skip (optional) Skips results
   * @param amount (optional) Specifies the amount of returned release notes. Defaults to 5
   */
  getReleaseInfos(
    environment: string | null | undefined,
    skip: number | null | undefined,
    amount: number | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<ReleaseVersionInfo[]> {
    let url_ = this.baseUrl + "/Info/releaseinfos?";
    if (environment !== undefined && environment !== null)
      url_ += "environment=" + encodeURIComponent("" + environment) + "&";
    if (skip !== undefined && skip !== null)
      url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    if (amount !== undefined && amount !== null)
      url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetReleaseInfos(_response);
      });
  }

  protected processGetReleaseInfos(
    response: Response
  ): Promise<ReleaseVersionInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as ReleaseVersionInfo[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ReleaseVersionInfo[]>(null as any);
  }

  sendSignupMail(
    email: string | null,
    signal?: AbortSignal | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/Info/signup/send/{email}";
    if (email === undefined || email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace("{email}", encodeURIComponent("" + email));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSendSignupMail(_response);
      });
  }

  protected processSendSignupMail(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  confirmSignupMail(
    code: string | null,
    signal?: AbortSignal | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/Info/signup/confirm/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConfirmSignupMail(_response);
      });
  }

  protected processConfirmSignupMail(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  unsubscribe(
    code: string | null,
    signal?: AbortSignal | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/Info/unsubscribe/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUnsubscribe(_response);
      });
  }

  protected processUnsubscribe(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }
}

export interface IPublicServicesClient {
  getAirlineByCode(airlineCode: string | null): Promise<Airline>;

  getAirportsByPrefix(prefix: string | null): Promise<Airport[]>;

  getAirportsByIata(iata: string | null): Promise<Airport>;

  getAirlinesByPrefix(prefix: string | null): Promise<Airline[]>;

  logo(id: string): Promise<FileResponse>;

  waitscreen(id: string): Promise<FileResponse>;

  airlineImage(code: string | null): Promise<FileResponse>;
}

export class PublicServicesClient
  extends AgentApiTypeScriptClientBase
  implements IPublicServicesClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getAirlineByCode(
    airlineCode: string | null,
    signal?: AbortSignal | undefined
  ): Promise<Airline> {
    let url_ =
      this.baseUrl + "/publicservices/GetFullAirlineName/{airlineCode}";
    if (airlineCode === undefined || airlineCode === null)
      throw new Error("The parameter 'airlineCode' must be defined.");
    url_ = url_.replace("{airlineCode}", encodeURIComponent("" + airlineCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAirlineByCode(_response);
      });
  }

  protected processGetAirlineByCode(response: Response): Promise<Airline> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Airline);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Airline>(null as any);
  }

  getAirportsByPrefix(
    prefix: string | null,
    signal?: AbortSignal | undefined
  ): Promise<Airport[]> {
    let url_ = this.baseUrl + "/publicservices/GetAirportsByPrefix/{prefix}";
    if (prefix === undefined || prefix === null)
      throw new Error("The parameter 'prefix' must be defined.");
    url_ = url_.replace("{prefix}", encodeURIComponent("" + prefix));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAirportsByPrefix(_response);
      });
  }

  protected processGetAirportsByPrefix(response: Response): Promise<Airport[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Airport[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Airport[]>(null as any);
  }

  getAirportsByIata(
    iata: string | null,
    signal?: AbortSignal | undefined
  ): Promise<Airport> {
    let url_ = this.baseUrl + "/publicservices/GetAirportByIata/{iata}";
    if (iata === undefined || iata === null)
      throw new Error("The parameter 'iata' must be defined.");
    url_ = url_.replace("{iata}", encodeURIComponent("" + iata));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAirportsByIata(_response);
      });
  }

  protected processGetAirportsByIata(response: Response): Promise<Airport> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Airport);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Airport>(null as any);
  }

  getAirlinesByPrefix(
    prefix: string | null,
    signal?: AbortSignal | undefined
  ): Promise<Airline[]> {
    let url_ = this.baseUrl + "/publicservices/GetAirlinesByPrefix/{prefix}";
    if (prefix === undefined || prefix === null)
      throw new Error("The parameter 'prefix' must be defined.");
    url_ = url_.replace("{prefix}", encodeURIComponent("" + prefix));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAirlinesByPrefix(_response);
      });
  }

  protected processGetAirlinesByPrefix(response: Response): Promise<Airline[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Airline[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Airline[]>(null as any);
  }

  logo(id: string, signal?: AbortSignal | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + "/publicservices/images/logo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLogo(_response);
      });
  }

  protected processLogo(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  waitscreen(
    id: string,
    signal?: AbortSignal | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/publicservices/images/waitscreen/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWaitscreen(_response);
      });
  }

  protected processWaitscreen(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  airlineImage(
    code: string | null,
    signal?: AbortSignal | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/publicservices/images/airline/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAirlineImage(_response);
      });
  }

  protected processAirlineImage(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export interface ILoginClient {
  /**
   * Login endpoint for token. Includes settings for Frontends.
   */
  loginByCredentials(model: LoginModel): Promise<LoginResult>;

  /**
   * Standard login endpoint for Auth Token retrival via Webname, Username and password.
   * @param webname Name of your company
   * @param username Username
   * @param password Password
   * @param universalTempDataID (optional) ID for Universal temp data
   */
  getToken(
    webname: string | null,
    username: string | null,
    password: string | null,
    universalTempDataID: string | null | undefined
  ): Promise<string>;

  loginByDeeplink(
    webID: string,
    deeplinkID: string,
    universalTempDataID: string | null | undefined
  ): Promise<LoginResult>;

  refreshToken(token: string | null): Promise<LoginResult>;

  webNameExists(webName: string | null): Promise<boolean>;

  userNameExists(
    webName: string | null,
    userName: string | null
  ): Promise<boolean>;
}

export class LoginClient
  extends AgentApiTypeScriptClientBase
  implements ILoginClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Login endpoint for token. Includes settings for Frontends.
   */
  loginByCredentials(
    model: LoginModel,
    signal?: AbortSignal | undefined
  ): Promise<LoginResult> {
    let url_ = this.baseUrl + "/Account/LoginByCredentials";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLoginByCredentials(_response);
      });
  }

  protected processLoginByCredentials(
    response: Response
  ): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  loginByCredentialsWithBranch(
    model: LoginModelWithBranch,
    signal?: AbortSignal | undefined
  ): Promise<LoginResult> {
    let url_ = this.baseUrl + "/Account/LoginByBranch";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(model);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLoginByCredentials(_response);
      });
  }

  protected processLoginByCredentialsWithBranch(
    response: Response
  ): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  /**
   * Standard login endpoint for Auth Token retrival via Webname, Username and password.
   * @param webname Name of your company
   * @param username Username
   * @param password Password
   * @param universalTempDataID (optional) ID for Universal temp data
   */
  getToken(
    webname: string | null,
    username: string | null,
    password: string | null,
    universalTempDataID: string | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<string> {
    let url_ =
      this.baseUrl + "/Account/get/token/{webname}/{username}/{password}?";
    if (webname === undefined || webname === null)
      throw new Error("The parameter 'webname' must be defined.");
    url_ = url_.replace("{webname}", encodeURIComponent("" + webname));
    if (username === undefined || username === null)
      throw new Error("The parameter 'username' must be defined.");
    url_ = url_.replace("{username}", encodeURIComponent("" + username));
    if (password === undefined || password === null)
      throw new Error("The parameter 'password' must be defined.");
    url_ = url_.replace("{password}", encodeURIComponent("" + password));
    if (universalTempDataID !== undefined && universalTempDataID !== null)
      url_ +=
        "universalTempDataID=" +
        encodeURIComponent("" + universalTempDataID) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetToken(_response);
      });
  }

  protected processGetToken(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  loginByDeeplink(
    webID: string,
    deeplinkID: string,
    universalTempDataID: string | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<LoginResult> {
    let url_ = this.baseUrl + "/Account/Login/{webID}/{deeplinkID}?";
    if (webID === undefined || webID === null)
      throw new Error("The parameter 'webID' must be defined.");
    url_ = url_.replace("{webID}", encodeURIComponent("" + webID));
    if (deeplinkID === undefined || deeplinkID === null)
      throw new Error("The parameter 'deeplinkID' must be defined.");
    url_ = url_.replace("{deeplinkID}", encodeURIComponent("" + deeplinkID));
    if (universalTempDataID !== undefined && universalTempDataID !== null)
      url_ +=
        "universalTempDataID=" +
        encodeURIComponent("" + universalTempDataID) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLoginByDeeplink(_response);
      });
  }

  protected processLoginByDeeplink(response: Response): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  async loginByDeeplinkWithBranch(
    webID: string,
    deeplinkID: string,
    branch: string,
    universalTempDataID: string | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<LoginResult> {
    let url_ =
      this.baseUrl + `/Account/LoginByBranch/${webID}/${deeplinkID}/${branch}`;
    if (webID === undefined || webID === null)
      throw new Error("The parameter 'webID' must be defined.");
    url_ = url_.replace("{webID}", encodeURIComponent("" + webID));
    if (deeplinkID === undefined || deeplinkID === null)
      throw new Error("The parameter 'deeplinkID' must be defined.");
    url_ = url_.replace("{deeplinkID}", encodeURIComponent("" + deeplinkID));
    if (universalTempDataID !== undefined && universalTempDataID !== null)
      url_ +=
        "universalTempDataID=" +
        encodeURIComponent("" + universalTempDataID) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLoginByDeeplink(_response);
      });
  }

  protected processLoginByDeeplinkWithBranch(
    response: Response
  ): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  refreshToken(
    token: string | null,
    signal?: AbortSignal | undefined
  ): Promise<LoginResult> {
    let url_ = this.baseUrl + "/Account/Login/RefreshToken/{token}";
    if (token === undefined || token === null)
      throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRefreshToken(_response);
      });
  }

  protected processRefreshToken(response: Response): Promise<LoginResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as LoginResult);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResult>(null as any);
  }

  webNameExists(
    webName: string | null,
    signal?: AbortSignal | undefined
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/Account/WebExists/{webName}";
    if (webName === undefined || webName === null)
      throw new Error("The parameter 'webName' must be defined.");
    url_ = url_.replace("{webName}", encodeURIComponent("" + webName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWebNameExists(_response);
      });
  }

  protected processWebNameExists(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userNameExists(
    webName: string | null,
    userName: string | null,
    signal?: AbortSignal | undefined
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/Account/UserNameExists/{webName}/{userName}";
    if (webName === undefined || webName === null)
      throw new Error("The parameter 'webName' must be defined.");
    url_ = url_.replace("{webName}", encodeURIComponent("" + webName));
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserNameExists(_response);
      });
  }

  protected processUserNameExists(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<boolean>(null as any);
  }
}

export interface IAvailableFaresClient {
  /**
   * Retrieves the configured options for the search process.
   */
  getFareSearchConfiguration(): Promise<AgentFrontendFareSearchOptions>;

  /**
   * Retrieves the configured options for the booking process.
   */
  getBookingConfiguration(): Promise<AgentBookFareConfiguration>;

  /**
   * Searches for available fares. If successfull, returns an ID which can be used to retrieve results with the corresponding endpoint.
   */
  searchAvailableFares(
    search: AvailableFaresSearchRequest
  ): Promise<FareSearchSubmitApiResponse>;

  /**
   * Retrieves a previously submitted search request via the provided ID.
   */
  getAvailableFaresResult(guid: string): Promise<GetAvailableFaresApiResponse>;

  /**
   * Returns flight details for an previously searched connection.
   */
  getFlightDetails(
    identifier: AvailableFareSelectionRequestModel
  ): Promise<FlightDetailsApiResponse>;

  /**
   * Returns information about available ancillary services for an previously searched connection.
   */
  getAncillaries(
    request: AvailableFareSelectionRequestModel
  ): Promise<GetAncillariesApiResponse>;

  /**
   * Returns information about the applied calculation rules of a connection.
   */
  getCalculationDetails(
    identifier: ConnectionIdentifier
  ): Promise<AvailFaresConnectionCalcDebugDetailsApiResponse>;

  /**
   * Returns a Rule information information text for a previously searched available fare.
   */
  getFareRuleInformationText(
    identifier: AvailableFareSelectionRequestModel
  ): Promise<GetRuleTextApiResponse>;

  /**
     * Excutes a booking for a previously searched available fare.
    It will validate the submitted input. If input is valid, submits the booking and return an confirmation.
     */
  submitBooking(
    input: FareBookingSubmitModel
  ): Promise<SmartBookingApiResponse>;
}

export class AvailableFaresClient
  extends AgentApiTypeScriptClientBase
  implements IAvailableFaresClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Retrieves the configured options for the search process.
   */
  getFareSearchConfiguration(
    signal?: AbortSignal | undefined
  ): Promise<AgentFrontendFareSearchOptions> {
    let url_ = this.baseUrl + "/availablefares/configuration/search";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFareSearchConfiguration(_response);
      });
  }

  protected processGetFareSearchConfiguration(
    response: Response
  ): Promise<AgentFrontendFareSearchOptions> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as AgentFrontendFareSearchOptions);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AgentFrontendFareSearchOptions>(null as any);
  }

  /**
   * Retrieves the configured options for the booking process.
   */
  getBookingConfiguration(
    signal?: AbortSignal | undefined
  ): Promise<AgentBookFareConfiguration> {
    let url_ = this.baseUrl + "/availablefares/configuration/booking";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBookingConfiguration(_response);
      });
  }

  protected processGetBookingConfiguration(
    response: Response
  ): Promise<AgentBookFareConfiguration> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as AgentBookFareConfiguration);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AgentBookFareConfiguration>(null as any);
  }

  /**
   * Searches for available fares. If successfull, returns an ID which can be used to retrieve results with the corresponding endpoint.
   */
  searchAvailableFares(
    search: AvailableFaresSearchRequest,
    signal?: AbortSignal | undefined
  ): Promise<FareSearchSubmitApiResponse> {
    let url_ = this.baseUrl + "/availablefares/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSearchAvailableFares(_response);
      });
  }

  protected processSearchAvailableFares(
    response: Response
  ): Promise<FareSearchSubmitApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as FareSearchSubmitApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FareSearchSubmitApiResponse>(null as any);
  }

  /**
   * Retrieves a previously submitted search request via the provided ID.
   */
  getAvailableFaresResult(
    guid: string,
    signal?: AbortSignal | undefined
  ): Promise<GetAvailableFaresApiResponse> {
    let url_ = this.baseUrl + "/availablefares/get/results/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAvailableFaresResult(_response);
      });
  }

  protected processGetAvailableFaresResult(
    response: Response
  ): Promise<GetAvailableFaresApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetAvailableFaresApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetAvailableFaresApiResponse>(null as any);
  }

  /**
   * Returns flight details for an previously searched connection.
   */
  getFlightDetails(
    identifier: AvailableFareSelectionRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<FlightDetailsApiResponse> {
    let url_ = this.baseUrl + "/availablefares/get/flightdetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(identifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFlightDetails(_response);
      });
  }

  protected processGetFlightDetails(
    response: Response
  ): Promise<FlightDetailsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as FlightDetailsApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FlightDetailsApiResponse>(null as any);
  }

  /**
   * Returns information about available ancillary services for an previously searched connection.
   */
  getAncillaries(
    request: AvailableFareSelectionRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<GetAncillariesApiResponse> {
    let url_ = this.baseUrl + "/availablefares/get/ancillaries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAncillaries(_response);
      });
  }

  protected processGetAncillaries(
    response: Response
  ): Promise<GetAncillariesApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetAncillariesApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetAncillariesApiResponse>(null as any);
  }

  /**
   * Returns information about the applied calculation rules of a connection.
   */
  getCalculationDetails(
    identifier: ConnectionIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<AvailFaresConnectionCalcDebugDetailsApiResponse> {
    let url_ = this.baseUrl + "/availablefares/get/connectioncalcdebug";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(identifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCalculationDetails(_response);
      });
  }

  protected processGetCalculationDetails(
    response: Response
  ): Promise<AvailFaresConnectionCalcDebugDetailsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as AvailFaresConnectionCalcDebugDetailsApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AvailFaresConnectionCalcDebugDetailsApiResponse>(
      null as any
    );
  }

  /**
   * Returns a Rule information information text for a previously searched available fare.
   */
  getFareRuleInformationText(
    identifier: AvailableFareSelectionRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<GetRuleTextApiResponse> {
    let url_ = this.baseUrl + "/availablefares/get/ruleinformationtext";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(identifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFareRuleInformationText(_response);
      });
  }

  protected processGetFareRuleInformationText(
    response: Response
  ): Promise<GetRuleTextApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetRuleTextApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetRuleTextApiResponse>(null as any);
  }

  /**
     * Excutes a booking for a previously searched available fare.
    It will validate the submitted input. If input is valid, submits the booking and return an confirmation.
     */
  submitBooking(
    input: FareBookingSubmitModel,
    signal?: AbortSignal | undefined
  ): Promise<SmartBookingApiResponse> {
    let url_ = this.baseUrl + "/availablefares/submitbooking";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(input);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSubmitBooking(_response);
      });
  }

  protected processSubmitBooking(
    response: Response
  ): Promise<SmartBookingApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as SmartBookingApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SmartBookingApiResponse>(null as any);
  }

  submitReBooking(
    input: FareBookingSubmitModel,
    signal?: AbortSignal | undefined
  ): Promise<SmartBookingApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/rebook/segments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(input);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSubmitBooking(_response);
      });
  }

  protected processSubmitReBooking(
    response: Response
  ): Promise<SmartBookingApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as SmartBookingApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SmartBookingApiResponse>(null as any);
  }
}

// ----------------------------------Hotel----------------------------------------
export class AvailableHotelsClient extends AgentApiHotelTypeScriptClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiHotelCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getHotelBaseUrl("", baseUrl);
  }

  async GetHotelIdsAsync(searchPhrase?: any) {
    console.log(this.baseUrl);
    let url_ =
      `https://api.ndc.live/Hotel` + `/GetHotelIdsAsync/${searchPhrase}/5000`;

    const hotelsId = fetch(url_)
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => {
        // Process the data returned from the API
        // Replace this with your custom handling of the data
        return data;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return hotelsId;
  }

  protected processGetFareHotelConfiguration(response: any): any {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText: any) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText: any) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<any>(null as any);
  }

  // GetHotelIdsAsync = async (searchPhrase?: string | undefined): Promise<any> => {
  //     let url_ = this.baseUrl + `/Hotel/GetHotelIdsAsync/${searchPhrase}/10`;
  //     // try {

  //     //     const response = await this.http.fetch(url_, {
  //     //         method: "GET",
  //     //         mode: 'no-cors',
  //     //         headers: {
  //     //             "Accept": "application/json"
  //     //         }
  //     //     });
  //     //     // console.log(response);
  //     //     if (!response.ok) {
  //     //         throw new Error("Network response was not ok.");
  //     //     }
  //     //     const data = await response.json();
  //     //     console.log(data); // Display the response data in the console
  //     //     return data; // Return the parsed JSON data

  //     await axios({
  //         method: 'get',
  //         url: url_,
  //     }).then(async function (response: any) {
  //         // handle success
  //         const data = await response.json();
  //         console.log(data);
  //     }).catch(function (error) {
  //         // handle error
  //         console.log(error);
  //     }).finally(function () {
  //         // always executed
  //     });
  //     // } catch (error) {
  //     //     console.error("Error fetching data:", error);
  //     //     throw error;
  //     // }
  // }

  GetHotelAsync(HotelId: any) {
    let url_ = `https://api.ndc.live/Hotel/GetHotelAsync/${HotelId}`;

    const hotels = fetch(url_)
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => {
        // Process the data returned from the API
        return data;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return hotels;
  }

  GetHotelsAsync = async (requestBody: any) => {
    try {
      const url_ = `https://api.ndc.live/Hotel/GetHotelsAsync`;

      const response = await fetch(url_, {
        method: "POST", // Change the method based on the API requirements (POST, GET, etc.)
        headers: {
          "Content-Type": "application/json", // Change the content type as per the API's requirements
        },
        body: JSON.stringify(requestBody), // Convert the data to JSON format if required
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json(); // Parse the response as JSON
      // Process the data returned from the API
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to handle it elsewhere if needed
    }
  };

  // GetRatesAsync(checkInDate_yyyyMMdd: number,
  //     nights: string, requestBody: any) {
  //     let date = moment(checkInDate_yyyyMMdd, "YYYYMMDD").format('YYYYMMDD');
  //     const firstFiftyValues = requestBody.slice(0, 50);
  //     const url_ = `https://api.ndc.live/Hotel/TESTGetRatesAsync/20231109/2`;
  //     const response = fetch(url_, {
  //         method: 'POST',
  //         headers: {
  //             'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(firstFiftyValues),
  //     }).then(response => response.json()).then(data => {
  //         console.log("data----------------", data);
  //         return data;
  //     }).catch(error => {
  //         console.error('Error fetching data:', error);
  //     });
  //     return response
  // }

  GetRatesAsync = async (
    adults: number,
    child: number,
    checkInDate_yyyyMMdd: any,
    rooms: number,
    nights: number,
    requestBody: any
  ) => {
    try {
      let date = moment(checkInDate_yyyyMMdd, "YYYYMMDD").format("YYYYMMDD");
      const currency = "EUR";
      const API_key = "1";
      const loginToken = "1";
      const url_ = `https://api.ndc.live/Hotel/GetRatesAsync/${adults}/${[
        child,
      ]}/${rooms}/${date}/${nights}/${currency}/${API_key}/${loginToken}`;

      const response = await fetch(url_, {
        method: "POST", // Change the method based on the API requirements (POST, GET, etc.)
        headers: {
          "Content-Type": "application/json", // Change the content type as per the API's requirements
        },
        body: JSON.stringify(requestBody), // Convert the data to JSON format if required
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json(); // Parse the response as JSON
      // Process the data returned from the API
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to handle it elsewhere if needed
    }
  };

  GetHotelPicturesAsync = async (hotelId: number) => {
    try {
      const url_ = `https://api.ndc.live/Hotel/GetHotelPicturesAsync/${hotelId}`;
      const response = await fetch(url_, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json(); // Parse the response as JSON
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to handle it elsewhere if needed
    }
  };

  GetPreBookHotel = async (
    hotelId: number,
    code: string,
    adults: number,
    date: string,
    nights: number
  ) => {
    const appKey = 1;
    const country = "india";
    let dateFormat = moment(date, "YYYYMMDD").format("YYYYMMDD");
    let currency = "EUR";
    try {
      const url_ = `https://api.ndc.live/Hotel/PreBookAsync/${hotelId}/${appKey}/${code}/${adults}/${dateFormat}/${nights}/${currency}/${country}`;
      const response = await fetch(url_, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json(); // Parse the response as JSON
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to handle it elsewhere if needed
    }
  };

  GetCancellationTermsAsync = async (
    roomCode: string,
    searchRequest: string
  ) => {
    const appKey = 1;
    const customization = `123`;
    try {
      const url_ = `https://api.ndc.live/Hotel/GetCancellationTermsAsync/${appKey}/${customization}/${roomCode}/${searchRequest}`;
      const response = await fetch(url_, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json(); // Parse the response as JSON
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to handle it elsewhere if needed
    }
  };
}

// ------------------------------end----------------------------
export interface IBookingManagerClient {
  /**
   * Syncs the data in bookingmanager with GDS.
   */
  syncBooking(
    bookingIdentifier: BookingIdentifier
  ): Promise<UpdatedBookingApiResponse>;

  getBookings(
    request: BookingMangerFilterRequestData,
    includeBookingDetails: boolean | null | undefined
  ): Promise<BookingManagementOverviewApiResponse>;

  getBookingDetails(
    bookingIdentifier: BookingIdentifier
  ): Promise<BookingDetailsApiResponse>;

  getPNR(bookingIdentifier: BookingIdentifier): Promise<GetPNRApiResponse>;

  getBookingDetailsByFileKey(
    filekey: string | null
  ): Promise<BookingDetailsApiResponse>;

  /**
   * Returns cancellation surcharges for webfares.
   */
  getCancelSurcharges(
    bookingIdentifier: BookingIdentifier
  ): Promise<GetCancelSurchargesApiResponse>;

  cancelBooking(
    bookingIdentifier: BookingIdentifier
  ): Promise<CancelBookingApiResponse>;

  cancelTicket(
    bookingIdentifier: BookingIdentifier
  ): Promise<CancelTicketApiResponse>;

  ticketBooking(
    bookingIdentifier: BookingIdentifier
  ): Promise<UpdatedBookingApiResponse>;

  /**
   * Returns possible and booked Ancillary services for a booking.
   */
  getServiceManagement(
    bookingIdentifier: BookingIdentifier
  ): Promise<BookingServicesManagementApiResponse>;

  /**
   * Returns SSR, OSI and other Elements in a booking.
   */
  getElementsManagement(
    bookingIdentifier: BookingIdentifier
  ): Promise<BookingElementsManagementApiResponse>;

  /**
   * Adds additional services to a booking.
   */
  addServices(
    service: AddServiceToBookingRequestModel
  ): Promise<BaseApiResponse>;

  /**
   * Adds elements to a booking.
   */
  addElements(
    request: AddElementsToBookingRequestModel
  ): Promise<BaseApiResponse>;

  /**
   * Removes addional services from a booking.
   */
  removeServices(
    service: RemoveServiceFromBookingRequestModel
  ): Promise<BaseApiResponse>;

  /**
   * Removes addional services from a booking.
   */
  removeElements(
    model: RemoveElementsFromBookingRequestModel
  ): Promise<BaseApiResponse>;

  importBooking(model: ImportBookingModel): Promise<BaseApiResponse>;

  downloadBackOfficeFile(
    bookingIdentifier: BookingIdentifier
  ): Promise<FileResponse | null>;

  downloadSalesReport(
    request: BookingManagerSalesReportRequestData
  ): Promise<FileResponse | null>;

  deleteNotification(model: DeleteNotificationModel): Promise<BaseApiResponse>;

  createOrUpdateNotification(
    model: UpdateNotificationModel
  ): Promise<BaseApiResponse>;
}
export class BookingManagerClient
  extends AgentApiTypeScriptClientBase
  implements IBookingManagerClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Syncs the data in bookingmanager with GDS.
   */
  syncBooking(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<UpdatedBookingApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/syncbooking";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSyncBooking(_response);
      });
  }

  protected processSyncBooking(
    response: Response
  ): Promise<UpdatedBookingApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UpdatedBookingApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdatedBookingApiResponse>(null as any);
  }

  getBookings(
    request: BookingMangerFilterRequestData,
    includeBookingDetails: boolean | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<BookingManagementOverviewApiResponse> {
    let url_ =
      this.baseUrl + "/bookingmanager/get/overview?includeBookingDetails=true";
    if (includeBookingDetails !== undefined && includeBookingDetails !== null)
      url_ +=
        "includeBookingDetails=" +
        encodeURIComponent("" + includeBookingDetails) +
        "&";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(request);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBookings(_response);
      });
  }

  protected processGetBookings(
    response: Response
  ): Promise<BookingManagementOverviewApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingManagementOverviewApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingManagementOverviewApiResponse>(null as any);
  }

  getBookingDetails(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<BookingDetailsApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/get/details";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBookingDetails(_response);
      });
  }

  protected processGetBookingDetails(
    response: Response
  ): Promise<BookingDetailsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingDetailsApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingDetailsApiResponse>(null as any);
  }

  getPNR(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<GetPNRApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/get/pnr";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPNR(_response);
      });
  }

  protected processGetPNR(response: Response): Promise<GetPNRApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetPNRApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetPNRApiResponse>(null as any);
  }

  getBookingDetailsByFileKey(
    filekey: string | null,
    signal?: AbortSignal | undefined
  ): Promise<BookingDetailsApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/get/details/filekey/{filekey}";
    if (filekey === undefined || filekey === null)
      throw new Error("The parameter 'filekey' must be defined.");
    url_ = url_.replace("{filekey}", encodeURIComponent("" + filekey));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBookingDetailsByFileKey(_response);
      });
  }

  protected processGetBookingDetailsByFileKey(
    response: Response
  ): Promise<BookingDetailsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingDetailsApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingDetailsApiResponse>(null as any);
  }

  /**
   * Returns cancellation surcharges for webfares.
   */
  getCancelSurcharges(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<GetCancelSurchargesApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/getcancelsurcharges";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCancelSurcharges(_response);
      });
  }

  protected processGetCancelSurcharges(
    response: Response
  ): Promise<GetCancelSurchargesApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetCancelSurchargesApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetCancelSurchargesApiResponse>(null as any);
  }

  cancelBooking(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<CancelBookingApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/cancel/booking";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelBooking(_response);
      });
  }

  protected processCancelBooking(
    response: Response
  ): Promise<CancelBookingApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as CancelBookingApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CancelBookingApiResponse>(null as any);
  }

  cancelTicket(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<CancelTicketApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/cancel/ticket";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelTicket(_response);
      });
  }

  protected processCancelTicket(
    response: Response
  ): Promise<CancelTicketApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as CancelTicketApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CancelTicketApiResponse>(null as any);
  }


  // cancel leg in booking manger

  cancelSegments(bookingIdentifier: BookingIdentifier, signal?: AbortSignal | undefined): Promise<CancelSegmentsApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/cancel/segments";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(bookingIdentifier);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelTicket(_response);
      });
  }

  protected processCancelSegments(
    response: Response
  ): Promise<CancelSegmentsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as CancelSegmentsApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CancelSegmentsApiResponse>(null as any);
  }


  ticketBooking(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<UpdatedBookingApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/orderpay";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTicketBooking(_response);
      });
  }

  protected processTicketBooking(
    response: Response
  ): Promise<UpdatedBookingApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UpdatedBookingApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdatedBookingApiResponse>(null as any);
  }

  splitBooking(bookingIdentifier: BookingIdentifiers, PassengersWhoSplitOff: number[], signal?: AbortSignal | undefined): Promise<any> {
    let url_ = this.baseUrl + "/bookingmanager/SplitPNR";
    url_ = url_.replace(/[?&]$/, "");

    // Ensure BookingIdentifier is correctly structured
    const content_ = JSON.stringify({ BookingIdentifier: bookingIdentifier, PassengersWhoSplitOff });

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSplitBooking(_response);
      });
  }

  protected processSplitBooking(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    const commandName = "SplitPNR";

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any);

        // ✅ responseMetaData
        const responseMetaData = {
          command: commandName,
          statusCode: status,
          timestamp: new Date().toISOString(),
          message: "Split booking successful",
          rawHeaders: _headers,
          requestId: _headers["x-request-id"] || null, // optional
        };
        return {
          ...result200,
          responseMetaData,
        };
      });
    } else {
      return response.text().then((_responseText) => {
        const responseMetaData = {
          command: commandName,
          statusCode: status,
          timestamp: new Date().toISOString(),
          message: "Split booking failed",
          rawHeaders: _headers,
          requestId: _headers["x-request-id"] || null, // optional
        };

        // Even on error, return responseMetaData for logging
        return Promise.reject({
          error: "An unexpected server error occurred.",
          status,
          body: _responseText,
          responseMetaData,
        });
      });
    }
  }


  /*
    Booking deprecated
  */
  async deprecateBooking(
    bookingIdentifier: BookingIdentifiers,
    signal?: AbortSignal
  ): Promise<DeprecateBookingResponse> {
    let url_ = `${this.baseUrl}/bookingmanager/SetBookingDeprecated`;

    const content_ = JSON.stringify({ BookingIdentifier: bookingIdentifier, Deprecated: true });

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const transformedOptions_ = await this.transformOptions(options_);
      const response = await this.http.fetch(url_, transformedOptions_);

      return this.processDeprecateBooking(response);
    } catch (error) {
      console.error("Error while deprecating booking:", error);
      throw new Error("Failed to deprecate booking");
    }
  }

  protected async processDeprecateBooking(response: Response): Promise<DeprecateBookingResponse> {
    const status = response.status;
    let _headers: any = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    const _responseText = await response.text();

    if (status === 200) {
      return _responseText === ""
        ? (null as any)
        : JSON.parse(_responseText) as DeprecateBookingResponse;
    } else {
      throw new Error(
        `API Error: ${status} - ${_headers["errorMessage"] || "Unexpected error"}`
      );
    }
  }

  /**
   * Returns possible and booked Ancillary services for a booking.
   */
  getServiceManagement(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<BookingServicesManagementApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/get/addedservices";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetServiceManagement(_response);
      });
  }

  protected processGetServiceManagement(
    response: Response
  ): Promise<BookingServicesManagementApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingServicesManagementApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingServicesManagementApiResponse>(null as any);
  }

  /**
   * Returns SSR, OSI and other Elements in a booking.
   */
  getElementsManagement(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<BookingElementsManagementApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/get/elements";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetElementsManagement(_response);
      });
  }

  protected processGetElementsManagement(
    response: Response
  ): Promise<BookingElementsManagementApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingElementsManagementApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingElementsManagementApiResponse>(null as any);
  }

  /**
   * Adds additional services to a booking.
   */
  addServices(
    service: AddServiceToBookingRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/add/services";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(service);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddServices(_response);
      });
  }

  protected processAddServices(response: Response): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  /**
   * Adds elements to a booking.
   */
  addElements(
    request: AddElementsToBookingRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/add/elements";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddElements(_response);
      });
  }

  protected processAddElements(response: Response): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  /**
   * Removes addional services from a booking.
   */
  removeServices(
    service: RemoveServiceFromBookingRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/remove/services";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(service);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveServices(_response);
      });
  }

  protected processRemoveServices(
    response: Response
  ): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  /**
   * Removes addional services from a booking.
   */
  removeElements(
    model: RemoveElementsFromBookingRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/remove/elements";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveElements(_response);
      });
  }

  protected processRemoveElements(
    response: Response
  ): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  importBooking(
    model: ImportBookingModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/import";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(model);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processImportBooking(_response);
      });
  }

  protected processImportBooking(response: Response): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  downloadBackOfficeFile(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<FileResponse | null> {
    console.log("hii", bookingIdentifier, signal);

    let url_ = this.baseUrl + "/bookingmanager/downloadbackofficefile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bookingIdentifier);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDownloadBackOfficeFile(_response);
      });
  }

  protected processDownloadBackOfficeFile(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  async SendConfirmTicket(
    bookingIdentifier: BookingIdentifier,
    signal?: AbortSignal | undefined
  ): Promise<string | null> {
    try {
      const url = `${this.baseUrl}/bookingmanager/sendConfirmTicket`;
      const content = JSON.stringify(bookingIdentifier);

      const options: RequestInit = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json", // Change this to "application/json" if you expect JSON response
        },
        body: content,
        signal,
      };

      const transformedOptions = await this.transformOptions(options);
      const response = await this.http.fetch(url, transformedOptions);

      if (response.ok) {
        return await this.processSendConfirmTicket(response);
      } else {
        // Handle non-200 status codes if needed
        return null; // You may want to return an error message or handle errors differently
      }
    } catch (error) {
      // Handle network errors or exceptions
      console.error("An error occurred:", error);
      return null; // You may want to return an error message or handle errors differently
    }
  }

  protected async processSendConfirmTicket(
    response: Response
  ): Promise<string | null> {
    const status = response.status;
    const _headers: Record<string, string> = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((value: string, key: string) => {
        _headers[key] = value;
      });
    }

    if (status === 200 || status === 206) {
      try {
        const text = await response.text();
        return text;
      } catch (error: any) {
        return throwException(
          "Error while processing the response.",
          status,
          error.message,
          _headers
        );
      }
    } else {
      const errorText = await response.text();
      return throwException(
        "An unexpected server error occurred.",
        status,
        errorText,
        _headers
      );
    }
  }

  async doNameChange(NameChangeRequestModel: NameChangeRequestModel) {
    try {
      const url = `${this.baseUrl}/bookingmanager/donamechange`;
      const options: RequestInit = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json", // Change this to "application/json" if you expect JSON response
        },
        body: JSON.stringify(NameChangeRequestModel),
      };

      const transformedOptions = await this.transformOptions(options);
      const response = await this.http.fetch(url, transformedOptions);

      if (response.ok) {
        return await this.processDoNameChange(response);
      } else {
        // Handle non-200 status codes if needed
        return null; // You may want to return an error message or handle errors differently
      }
    } catch (error) {
      // Handle network errors or exceptions
      console.error("An error occurred:", error);
      return null; // You may want to return an error message or handle errors differently
    }
  }

  protected async processDoNameChange(
    response: Response
  ): Promise<string | null> {
    const status = response.status;
    const _headers: Record<string, string> = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((value: string, key: string) => {
        _headers[key] = value;
      });
    }

    if (status === 200 || status === 206) {
      try {
        const text = await response.text();
        return text;
      } catch (error: any) {
        return throwException(
          "Error while processing the response.",
          status,
          error.message,
          _headers
        );
      }
    } else {
      const errorText = await response.text();
      return throwException(
        "An unexpected server error occurred.",
        status,
        errorText,
        _headers
      );
    }
  }

  downloadSalesReport(
    request: BookingManagerSalesReportRequestData,
    signal?: AbortSignal | undefined
  ): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/bookingmanager/downloadsalesreport";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDownloadSalesReport(_response);
      });
  }

  protected processDownloadSalesReport(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  deleteNotification(
    model: DeleteNotificationModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/notifications/delete";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteNotification(_response);
      });
  }

  protected processDeleteNotification(
    response: Response
  ): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  createOrUpdateNotification(
    model: UpdateNotificationModel,
    signal?: AbortSignal | undefined
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/notifications/update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateOrUpdateNotification(_response);
      });
  }

  protected processCreateOrUpdateNotification(
    response: Response
  ): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BaseApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BaseApiResponse>(null as any);
  }

  confirmChanges(
    model: ConfirmNotifications,
    signal?: AbortSignal
  ): Promise<BaseApiResponse> {
    let url_ = this.baseUrl + "/bookingmanager/ConfirmChanges";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    const options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processConfirmChanges(_response));
  }

  protected processConfirmChanges(response: Response): Promise<BaseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers?.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    return response.text().then((_responseText) => {
      if (status === 200) {
        const result =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BaseApiResponse);
        return result;
      }

      if (status === 400) {
        const validationErrors = _responseText ? JSON.parse(_responseText) : {};
        return throwException(
          "Validation failed.",
          status,
          validationErrors,
          _headers
        );
      }

      if (status !== 204) {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      }

      return null as any;
    });
  }

  getFareRules(
    bookingIdentifier: BookingId,
    signal?: AbortSignal
  ): Promise<FareRulesResponse> {
    const url = `${this.baseUrl}/bookingmanager/get/fareRules`;
    const content = JSON.stringify(bookingIdentifier);

    const options: RequestInit = {
      method: "POST",
      body: content,
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options)
      .then((transformedOptions) => this.http.fetch(url, transformedOptions))
      .then((response) => this.processGetFareRules(response))
      .catch((error) => {
        console.error("API error:", error);
        throw error; // Re-throw to propagate the error to the caller
      });
  }

  protected processGetFareRules(
    response: Response
  ): Promise<FareRulesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as FareRulesResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FareRulesResponse>(null as any);
  }

  getBookingCommunication(
    bookingIdentifier: BookingId,
    signal?: AbortSignal
  ): Promise<BookingCommunicationResponse> {
    const url = `${this.baseUrl}/bookingmanager/get/bookingCommunication`;
    const content = JSON.stringify(bookingIdentifier);
    const options: RequestInit = {
      method: "POST",
      body: content,
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options)
      .then((transformedOptions) => this.http.fetch(url, transformedOptions))
      .then((response) => this.processGetBookingCommunication(response))
      .catch((error) => {
        console.error("API error:", error);
        throw error; // Re-throw to propagate the error to the caller
      });
  }

  protected processGetBookingCommunication(
    response: Response
  ): Promise<BookingCommunicationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BookingCommunicationResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BookingCommunicationResponse>(null as any);
  }
}


//paymentData

export enum SettingsOrder {
  Web = 0,
  BranchGroup = 1,
  Branch = 2,
}
export interface UpdatePaymentDataSettingsModel {
  id: string;
  webID: string;
  created: Date;
  lastModified: Date;
  filterBranchGroupID: string;
  filterBranchID: string;
  webHierarchy: number;
  title1: string;
  title2: string;
  title10: string;
  code1: string;
  code10: string;
  minlen1: number;
  minlen10: number;
  maxLen1: number;
  maxLen10: number;
  fieldType1: string;
  fieldType10: string;
}
export interface IPaymentDataSettingsClient {
  get(
    level: SettingsOrder | undefined,
    id: string | null | undefined
  ): Promise<UpdatePaymentDataSettingsModel>;
}
export class PaymentDataSettingsClient
  extends AgentApiTypeScriptClientBase
  implements IPaymentDataSettingsClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }
  get(
    level: SettingsOrder | undefined,
    id: string | null | undefined,
    signal?: AbortSignal | undefined
  ): Promise<UpdatePaymentDataSettingsModel> {
    let url_ = this.baseUrl + "/apiadmin/PaymentDataSettings/get?";
    if (level === null)
      throw new Error("The parameter 'level' cannot be null.");
    else if (level !== undefined)
      url_ += "level=" + encodeURIComponent("" + level) + "&";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGet(_response);
      });
  }

  protected processGet(
    response: Response
  ): Promise<UpdatePaymentDataSettingsModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UpdatePaymentDataSettingsModel);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdatePaymentDataSettingsModel>(null as any);
  }
}

export interface ICustomerProfilesClient {
  delete(id: string): Promise<void>;

  /**
   * Retrieves a list of stored entities.
   * @return Stored entity
   */
  list(): Promise<UpdateCustomerProfileDataRequest[]>;

  /**
   * Retrieves a stored entity
   * @return Stored entity
   */
  get(id: string): Promise<UpdateCustomerProfileDataRequest>;

  /**
   * Adds or edit a customer profile.
   * @return ID of Temp data
   */
  update(data: UpdateCustomerProfileDataRequest): Promise<string>;
}

export class CustomerProfilesClient
  extends AgentApiTypeScriptClientBase
  implements ICustomerProfilesClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  delete(id: string, signal?: AbortSignal | undefined): Promise<void> {
    let url_ = this.baseUrl + "/customerprofiles/delete/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Retrieves a list of stored entities.
   * @return Stored entity
   */
  list(
    signal?: AbortSignal | undefined
  ): Promise<UpdateCustomerProfileDataRequest[]> {
    let url_ = this.baseUrl + "/customerprofiles/list";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processList(_response);
      });
  }

  protected processList(
    response: Response
  ): Promise<UpdateCustomerProfileDataRequest[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UpdateCustomerProfileDataRequest[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateCustomerProfileDataRequest[]>(null as any);
  }

  /**
   * Retrieves a stored entity
   * @return Stored entity
   */
  get(
    id: string,
    signal?: AbortSignal | undefined
  ): Promise<UpdateCustomerProfileDataRequest> {
    let url_ = this.baseUrl + "/customerprofiles/get/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGet(_response);
      });
  }

  protected processGet(
    response: Response
  ): Promise<UpdateCustomerProfileDataRequest> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UpdateCustomerProfileDataRequest);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateCustomerProfileDataRequest>(null as any);
  }

  /**
   * Adds or edit a customer profile.
   * @return ID of Temp data
   */
  update(
    data: UpdateCustomerProfileDataRequest,
    signal?: AbortSignal | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/customerprofiles/update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as AdminEntityValidationResult);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }
}
export interface IFaresDisplayClient {
  /**
   * Retrieves a previously searched Faredisplay result
   * @param guid ID returned by the
   * @deprecated
   */
  getFareDisplayResult(guid: string): Promise<GetFareDisplayApiResponse>;

  /**
   * Submits a search for an faredisplay. If successfull, returns an ID where the results of the search can be retrieved
   * @deprecated
   */
  searchFareDisplay(
    search: FareDisplaySearchRequest
  ): Promise<FareSearchSubmitApiResponse>;
}
export class FaresDisplayClient
  extends AgentApiTypeScriptClientBase
  implements IFaresDisplayClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Retrieves a previously searched Faredisplay result
   * @param guid ID returned by the
   * @deprecated
   */
  getFareDisplayResult(
    guid: string,
    signal?: AbortSignal | undefined
  ): Promise<GetFareDisplayApiResponse> {
    let url_ = this.baseUrl + "/faredisplay/get/results/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFareDisplayResult(_response);
      });
  }

  protected processGetFareDisplayResult(
    response: Response
  ): Promise<GetFareDisplayApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetFareDisplayApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetFareDisplayApiResponse>(null as any);
  }

  /**
   * Submits a search for an faredisplay. If successfull, returns an ID where the results of the search can be retrieved
   * @deprecated
   */
  searchFareDisplay(
    search: FareDisplaySearchRequest,
    signal?: AbortSignal | undefined
  ): Promise<FareSearchSubmitApiResponse> {
    let url_ = this.baseUrl + "/faredisplay/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSearchFareDisplay(_response);
      });
  }

  protected processSearchFareDisplay(
    response: Response
  ): Promise<FareSearchSubmitApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as FareSearchSubmitApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FareSearchSubmitApiResponse>(null as any);
  }
}
export interface IReportingClient {
  getAllotmentInfo(
    request: GetAllotmentInfoRequestModel
  ): Promise<GetAllotmentInfoApiResponse>;
  getPossibleDepartureDates(request: any): Promise<any>;
}
export class ReportingClient
  extends AgentApiTypeScriptClientBase
  implements IReportingClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getAllotmentInfo(
    request: GetAllotmentInfoRequestModel,
    signal?: AbortSignal | undefined
  ): Promise<GetAllotmentInfoApiResponse> {
    let url_ = this.baseUrl + "/reporting/get/allotmentinfo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllotmentInfo(_response);
      });
  }

  protected processGetAllotmentInfo(response: Response): Promise<GetAllotmentInfoApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as GetAllotmentInfoApiResponse);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetAllotmentInfoApiResponse>(null as any);
  }

  // get Possible departure dates
  getPossibleDepartureDates(
    data: object,
    signal?: AbortSignal | undefined
  ): any {
    let url_ = `${this.baseUrl}/reporting/get/possibledeparturedates`;
    const content_ = JSON.stringify(data);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return fetch(url_, transformedOptions_);
      })
      .then((_response: any) => {
        return _response.json();
      })
      .then((data) => {
        return data;
      });
  }

  protected processGetPossibleDepartureDates(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetAllotmentInfoApiResponse>(null as any);
  }
}

export interface IAdminFrontendServicesClient {
  getBranchOptionsByBranchgroupID(
    branchgroupid: string
  ): Promise<BranchOption[]>;

  getBranchOptionById(branchid: string): Promise<BranchOption>;

  getBranchGroupOptionById(branchgroupid: string): Promise<BranchGroupOption>;

  getBranchGroupOptions(): Promise<BranchGroupOption[]>;

  getUserOptionsByBranchGroupID(branchgroupid: string): Promise<UserOption[]>;

  getUserOptionsByBranchID(branchid: string): Promise<UserOption[]>;
}

export class AdminFrontendServicesClient
  extends AgentApiTypeScriptClientBase
  implements IAdminFrontendServicesClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: ApiCredentialsOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getBranchOptionsByBranchgroupID(
    branchgroupid: string,
    signal?: AbortSignal | undefined
  ): Promise<BranchOption[]> {
    let url_ =
      this.baseUrl +
      "/api/admin/frontend/services/branch/options/branchgroup/id/{branchgroupid}";
    if (branchgroupid === undefined || branchgroupid === null)
      throw new Error("The parameter 'branchgroupid' must be defined.");
    url_ = url_.replace(
      "{branchgroupid}",
      encodeURIComponent("" + branchgroupid)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBranchOptionsByBranchgroupID(_response);
      });
  }

  protected processGetBranchOptionsByBranchgroupID(
    response: Response
  ): Promise<BranchOption[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BranchOption[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BranchOption[]>(null as any);
  }

  getBranchOptionById(
    branchid: string,
    signal?: AbortSignal | undefined
  ): Promise<BranchOption> {
    let url_ =
      this.baseUrl +
      "/api/admin/frontend/services/branch/options/id/{branchid}";
    if (branchid === undefined || branchid === null)
      throw new Error("The parameter 'branchid' must be defined.");
    url_ = url_.replace("{branchid}", encodeURIComponent("" + branchid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBranchOptionById(_response);
      });
  }

  protected processGetBranchOptionById(
    response: Response
  ): Promise<BranchOption> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BranchOption);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BranchOption>(null as any);
  }

  getBranchGroupOptionById(
    branchgroupid: string,
    signal?: AbortSignal | undefined
  ): Promise<BranchGroupOption> {
    let url_ =
      this.baseUrl +
      "/api/admin/frontend/services/branchgroup/options/id/{branchgroupid}";
    if (branchgroupid === undefined || branchgroupid === null)
      throw new Error("The parameter 'branchgroupid' must be defined.");
    url_ = url_.replace(
      "{branchgroupid}",
      encodeURIComponent("" + branchgroupid)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBranchGroupOptionById(_response);
      });
  }

  protected processGetBranchGroupOptionById(
    response: Response
  ): Promise<BranchGroupOption> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BranchGroupOption);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BranchGroupOption>(null as any);
  }

  getBranchGroupOptions(
    signal?: AbortSignal | undefined
  ): Promise<BranchGroupOption[]> {
    let url_ =
      this.baseUrl + "/api/admin/frontend/services/branchgroup/options/all";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBranchGroupOptions(_response);
      });
  }

  protected processGetBranchGroupOptions(
    response: Response
  ): Promise<BranchGroupOption[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as BranchGroupOption[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BranchGroupOption[]>(null as any);
  }

  getUserOptionsByBranchGroupID(
    branchgroupid: string,
    signal?: AbortSignal | undefined
  ): Promise<UserOption[]> {
    let url_ =
      this.baseUrl +
      "/api/admin/frontend/services/getuseroptionsbybranchgroup/id/{branchgroupid}";
    if (branchgroupid === undefined || branchgroupid === null)
      throw new Error("The parameter 'branchgroupid' must be defined.");
    url_ = url_.replace(
      "{branchgroupid}",
      encodeURIComponent("" + branchgroupid)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUserOptionsByBranchGroupID(_response);
      });
  }

  protected processGetUserOptionsByBranchGroupID(
    response: Response
  ): Promise<UserOption[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UserOption[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserOption[]>(null as any);
  }

  getUserOptionsByBranchID(
    branchid: string,
    signal?: AbortSignal | undefined
  ): Promise<UserOption[]> {
    let url_ =
      this.baseUrl +
      "/api/admin/frontend/services/getuseroptionsbybranch/id/{branchid}";
    if (branchid === undefined || branchid === null)
      throw new Error("The parameter 'branchid' must be defined.");
    url_ = url_.replace("{branchid}", encodeURIComponent("" + branchid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUserOptionsByBranchID(_response);
      });
  }

  protected processGetUserOptionsByBranchID(
    response: Response
  ): Promise<UserOption[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as UserOption[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserOption[]>(null as any);
  }
}

export interface BookingManagerFilterOptionsResponse {
  branchGroups: BranchGroupOption[];
  branches: BranchOption[];
  users: UserOption[];
  membershipMembers: membershipMembers[]
}

export interface membershipMembers {
  name: string | undefined;
}

export interface BranchGroupOption {
  label: string | undefined;
  id: string | undefined;
}
export interface BranchOption {
  label: string | undefined;
  id: string | undefined;
  branchGroupName: string | undefined;
  branchGroupId: string | undefined;
}
export interface UserOption {
  name: string | undefined;
  id: string | undefined;
}
export interface BookingManagerFilterOptionsRequest {
  branchgroup: string | undefined;
  branch: string | undefined;
}
export interface LoginResult {
  success: boolean;
  token: string | undefined;
  errorMessages: string[] | undefined;
  agentFrontendSettings: AgentFrontendSettings;
  isAdmin: boolean;
}

export interface AgentFrontendSettings {
  showBookingManagerTab: boolean;
  allowedBookingManagerGlobalFeatures: AgentPlusBookingManagerGlobalFeature[];
  showFareQueryTab: boolean;
  otherSettingsAsKeyValueText: string;
  b2cSettingsText: string;
  enableCalculationDeugger: boolean;
  startPage: StartPage;
  logoID: string;
  customerProfileData: UpdateCustomerProfileDataRequest | undefined;
  waitScreenID: string;
  dateFormat: string | undefined;
  locale: string | undefined;
  preferredCountry: string | undefined;
  currency: string;
  bookingManagerWebAccess: WebAccessEnum;
  budgetInfo: AgentBudgetInfo | undefined;
  paymentDataSettings: string;
  showAgencyCalcTooltip: boolean;
  showConsolidatorCalcTooltip: boolean;
}

export enum AgentPlusBookingManagerGlobalFeature {
  None = 0,
  ImportBooking = 1,
  DownloadSalesReport = 2,
}

export enum StartPage {
  Query = 0,
  BookingManager = 1,
}

export interface UpdateCustomerProfileDataRequest {
  /** To create new data, leave empty. To Edit existing data provide ID of existing data. */
  id: string | undefined;
  /** Optional title.  */
  title: string | undefined;
  data: CustomerProfileData;
  /** Optional field to set the expire date. Defaults to 24 hours. */
  validUntil: InvariantDateTimeModel | undefined;
}

export interface CustomerProfileData {
  passengers: CustomerProfilePassengers | undefined;
  flightDetails: CustomerProfilesFlightDetails | undefined;
  invoice: Adress | undefined;
  delivery: Adress | undefined;
}

export interface CustomerProfilePassengers {
  adults: CustomerProfilePassengerGroup | undefined;
  children: CustomerProfilePassengerGroup | undefined;
  infants: CustomerProfilePassengerGroup | undefined;
}

export interface CustomerProfilePassengerGroup {
  passengerType: string;
  passengers: CustomerProfilePassenger[];
}

export interface CustomerProfilePassenger {
  title: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: InvariantDateModel | undefined;
  gender: AgentGenderEnum;
  frequentFlyerCards: BonusProgramModel[] | undefined;
}

/** Object for submitting Date only values. Values are 1- based (e.g Month January - 1, February- 2...) */
export interface InvariantDateModel {
  day: number;
  month: number;
  year: number;
}

export enum AgentGenderEnum {
  Unknown = 0,
  Male = 1,
  Female = 2,
}

export interface BonusProgramModel {
  /** Collection of carriers the program should be used */
  carrierCodes: string[];
  /** WFE only: Optional free text field for possible extensions. */
  extensions: string | undefined;
  /** WFE only: Optional firstname of the card holder. */
  holderFirstName: string | undefined;
  /** WFE only: Optional surname of the card holder. */
  holderLastName: string | undefined;
  /** WFE only: Optional title of the card holder. */
  holderTitle: string | undefined;
  /** Number of the bonus program. */
  programNumber: string;
  /** WFE only: Optional type of the bonus program. */
  programType: string | undefined;
}

export interface CustomerProfilesFlightDetails {
  segments: CustomerProfileSegment[] | undefined;
  cabinClasses: CabinClassInput | undefined;
  directFlightsOnly: boolean;
  includeAirlines: string[] | undefined;
  excludeAirlines: string[] | undefined;
  SmartAirlines: string[] | undefined;
  targetMultiChannelBranch: string | undefined;
  targetMultiChannelBranchgroup: string | undefined;
}

export interface CustomerProfileSegment {
  departure: string | undefined;
  arrival: string | undefined;
  radius: number;
  departureDate: InvariantDateModel | undefined;
  cabinClasses: CabinClassInput | undefined;
}

export interface CabinClassInput {
  economy: boolean;
  premiumEconomy: boolean;
  business: boolean;
  first: boolean;
}

export interface Adress {
  firstName: string | undefined;
  lastName: string | undefined;
  title: string | undefined;
  emailAddress: string | undefined;
  phoneNumber: string | undefined;
  street: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  country: string | undefined;
  ConfirmationLanguage: string | undefined
}

interface IFlightCollapse {
  [key: string]: {
    Checked: boolean
  };
}

export interface b2cSettingsText {
  HotelTab: string | undefined;
  AirPortSearchType: string | undefined;
  ShowLanguageDecimalTabB2C: string | undefined;
  ShowLanguageDecimalTabB2B: string | undefined;
  ShowExtraAncillariesTabB2C: string | undefined;
  ShowDateInput: string | undefined;
  ShowDefaultFilter: string | undefined;
  CabinClass: CabinClassInterface;
  TermsConditionsLink: string | undefined;
  ShowBackgroundModalColor: string;
  showMarqueeText: string | undefined;
  showMarqueeFrom: string | undefined;
  showMarqueeTo: string | undefined;
  showBrandName: string | undefined;
  showFilterPosition: string | undefined;
  priceOption: string | undefined;
  showAssistance: string | undefined;
  Style: string | undefined;
  ConfirmationText: string | undefined;
  filtersOrderB2B: string | any;
  filtersOrderB2C: string | any
  fareShowB2B: IFlightCollapse;
  showUpsellB2B: string;
  showLanguageB2B: string;
  showUpsell: string;
  showSplitBooking: string;
  allowedBookingManagerCouponColumns: AgentPlusBookingManagerColumns[];
}

/** Object for submitting Datetime values. Values are 1- based (e.g Month January - 1, February- 2...) */
export interface InvariantDateTimeModel extends InvariantDateModel {
  hour: number;
  minute: number;
  second: number;
}

export enum WebAccessEnum {
  Web = 0,
  Branchgroup = 1,
  Branch = 2,
  User = 3,
}

export interface AgentBudgetInfo {
  currentBudget: number;
  maximumBudget: number;
  depositVersionID: string;
  webHierarchy: SettingsOrder;
}

export interface FapiLoginSettingsModel {
  username: string | undefined;
  password: string | undefined;
}

export interface VersionInformationModel {
  flightApiVersions: FlightApiVersionInfo[];
  agentBackendVersion: string;
  agentBackendEnvironment: string;
  flightApiServer: string;
  buildInfo: BuildInfo;
  latestReleaseInfo: ReleaseVersionInfo | undefined;
}

export interface FlightApiVersionInfo {
  module: string | undefined;
  build: number;
  major: number;
  minor: number;
  revision: number;
}

export interface BuildInfo {
  deployedGitCommitHashShort: string | undefined;
  deployedGitCommitHashLong: string | undefined;
  deployedGitBranch: string | undefined;
  deployedEnivronment: string | undefined;
  buildNumber: string | undefined;
  version: string | undefined;
}

export interface ReleaseVersionInfo {
  version: string;
  environment: string;
  date: Date;
  releaseNotes: ReleaseInfoMessage[];
}

export interface ReleaseInfoMessage {
  message: string;
  affectsDisplay: string;
  affectsValue: ChangelogMessageAffectEnum;
}

export enum ChangelogMessageAffectEnum {
  General = 0,
  Agent = 1,
  Admin = 2,
  RestAPI = 3,
}

export interface Airline {
  code: string;
  hyperlink: string;
  hint: string;
  allianceCode: string;
  allianceName: string;
}

export interface Airport {
  iataCode: string;
  iata: string;
  code: string;
  name: string;
  nameDictionary: Record<string, string>;
  cityCode: string;
  cityName: string;
  cityNameDictionary: Record<string, string>;
  countryCode: string;
  countryName: string;
  stateCode: string;
  stateName: string;
  continentCode: string;
  continentName: string;
  icao: string;
  areaCode: number | null;
  longitude: string;
  latitude: string;
  allAirports: boolean;
  isFrequent: boolean;
  runway: number;
}


/** Login model for standard Login via Username and password. */
export interface LoginModel {
  /** The Agent User Username. */
  username: string;
  /** Password */
  password: string;
  webname: string | undefined;
  support: boolean;
  supportname: string | undefined;
  universalTempDataID: string | undefined;
}

export interface LoginModelWithBranch {
  username: string;
  password: string;
  branchName: string;
  webname: string | undefined;
  support: boolean;
}

export interface AgentFrontendFareSearchOptions {
  passengerConfiguration: AgentFrontendPassengerConfiguation;
  maximumTotalAmountOfPassengers: number;
}

export interface AgentFrontendPassengerConfiguation {
  adultConfigurations: AgentFrontendPassengerTypeConfig[];
  childConfigurations: AgentFrontendPassengerTypeConfig[];
  infantConfigurations: AgentFrontendPassengerTypeConfig[];
}

export interface AgentFrontendPassengerTypeConfig {
  label: string;
  isEnabled: boolean;
  ageRequired: boolean;
  minAge: number;
  minAgeRequired: boolean;
  maxAge: number;
  maxAgeRequired: boolean;
  ageLabel: string;
  type: string;
}

export interface AgentBookFareConfiguration {
  address: Adress | undefined;
  addressBehavior: BookingAddressBehavior;
  invoice: Adress | undefined;
  webfarePassword: string | undefined;
  webfarePasswordBehavior: BookingAddressBehavior;
  emergencyphone: string | undefined;
  emergencyPhoneBehavior: BookingAddressBehavior;
  bookingConfirmationEmail: string | undefined;
}

export enum BookingAddressBehavior {
  UseBranchAdress = 0,
  PrefillWithBranchAdress = 1,
  EmptyUserInput = 2,
}

/** Base Object of an API Response. In case of an error the Result is null, and the ResponseMetaData will contain further information about the error occured. */
export interface BaseApiResponse {
  /** Contains additional Information about the Response, e.g the transactions performed in the request. If The Request failed it will contain information about the error occured.         */
  responseMetaData: BaseApiResponseMetaData;
}

export interface FareSearchSubmitApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: FareSubmitResult | undefined;
}

export interface FareSubmitResult {
  /** Contains the result of the submitted search. Is null if a Validation error occured. */
  fareSearchResult: AvailableFareResultModel | undefined;
  validationResult: InputValidationResult;
}

export interface AvailableFareResultModel {
  /** List of returned fares. */
  fares: AvailableFareModel[];
  validUntil: Date;
  defaultFilterSettings: DefaultAvailFaresfilterSettings;
  submittedSearch: AvailableFaresSearchRequest;
  /** ID of the cached Fare result.Used for follow-up requests and can be used for retriving the fares result */
  fareResultID: string;
  multiChannelRuleInfo: MultiChannelRuleInfoModel | undefined;
}

export interface AvailableFareModel {
  isWebFare: boolean;
  currency: string | undefined;
  totalPrice: number;
  totalTax: number;
  fareIndex: number;
  identifier: FareIdentifier;
  legs: AvailableFareLegModel[];
  fareHeader: FareHeaderView;
  fareInfoBox: FareInfoBoxView;
  includedServices: InludedServiceMainGroup[];
  ticketGroupOptions: FareTicketGroupOptions[];
  apisRequirenments: FareAPISRequirements;
  calculationResult: Calculation_Result;
  bookingPassengers: FareBookingPassengerView[];
  travelHeaderMinSum: TravelHeaderMin
}

export interface FareIdentifier {
  /** Index of the requested fare in the Fare result. 0 based */
  fareIndex: number;
  /** ID of the cached Fare result.Used for follow-up requests and can be used for retriving the fares result */
  fareResultID: string;
}

export interface FlightData {
  carrierCode: string | undefined;
  hint: string | undefined;
  currency: string | undefined;
  totalPrice: number;
  fareIndex: number;
  salesPreferencePriority: number | undefined;
  time: {
    minutes: number;
    hours: number;
    addHours: number;
    daysStayOver: number;
  };
}

export interface AvailableFareLegModel {
  index: number;
  /** Container for additional rule specific data. */
  legFareInfo: LegFareInfoModel | undefined;
  fareIndex: number;
  carrierCode: string | undefined;
  platingCarrier: Airline | undefined;
  fareTypeInformation: FareTypeInformation;
  travelHeaderMin: TravelHeaderMin;
  connections: AvailableFareConnectionModel[];
  apisRequirenments: FareAPISRequirements | undefined;
  supportedFunction: LegSupportedFunctions | undefined;
  isWeb: boolean;
  recordset: string;
}

export interface LegFareInfoModel {
  /** Net fares only: Optional result parameter containing the rule booking class of the leg.  */
  bookingClass: string | undefined;
  /** Net fares only: Result parameter containing the rule fare base of the leg.  */
  farebase: string | undefined;
  /** Optional Identifier for the CabinClass Value of the returned fare family */
  legCabinClass: ClassTypeEnum | undefined;
  /** Container for the advanced booking restrictions of the rule and the age limits of the passenger. */
  rule: FareResponseRuleModel | undefined;
  /** NetFares only: This parameter defines whether the fare was loaded in HitchHiker Entry as 
            •	Consolidator
            •	Touroperator */
  tariffType: TariffTypeEnum | undefined;
  /** NetFares only: This parameter defines whether the fare was loaded in HitchHiker Entry as 
            •	Net
            •	Published
            •	Corporate */
  tariffSubType: TariffSubTypeEnum | undefined;
  /** Container for the advanced ticket restrictions of the rule. */
  ticket: FareResponseTicketModel | undefined;
  /** The tariffmatchcode from the Entry database – can be useful as additional fare identification parameter. */
  tariffMatchCode: string | undefined;
  /** NetFare only: Flag to define if the taxes are ignored or not. */
  taxesIgnored: boolean | undefined;
}

export enum ClassTypeEnum {
  None = 1,
  Economy = 2,
  Business = 4,
  First = 8,
  PremiumEconomy = 16,
  All = 32,
}

export interface FareResponseRuleModel {
  /** The last permitted booking date, empty if no last booking date is defined in the data. */
  lastBookingDate: Date | undefined;
  /** Net Fares only: The rule match code */
  matchCode: string | undefined;
  /** Maximum age allowed for this fare. This parameter is only filled for net fares. */
  maxAge: number | undefined;
  /** Minimum age allowed for this fare. This parameter is only filled for net fares. */
  minAge: number | undefined;
  /** Minimum number of days between booking and departure; empty if no restriction is known. */
  minBookingBeforeDep: number | undefined;
  /** Possible penalty as free text from the GDS. */
  penalty: string | undefined;
  /** Parameter to allow special discounted fares to be returned during the request by any carrier applicable.
            Available values are: 
            •	NoDiscountedFares
            •	SpainIslandsResidentialDiscount
            •	SpainGeneralLargeFamilyDiscount
            •	SpainSpecialLargeFamilyDiscount */
  specialDiscount: DiscountEnum | undefined;
}

export enum DiscountEnum {
  NoDiscountedFares = 1,
  SpainIslandsResidentialDiscount = 2,
  SpainGeneralLargeFamilyDiscount = 4,
  SpainSpecialLargeFamilyDiscount = 8,
}

export enum TariffTypeEnum {
  None = 1,
  Consolidator = 2,
  Touroperator = 4,
}

export enum TariffSubTypeEnum {
  None = 1,
  Net = 2,
  Published = 4,
  Corporate = 8,
}

export interface FareResponseTicketModel {
  /** The last permitted ticketing date, empty if no last ticketing date is defined in the data. */
  lastTicketingDate: Date | undefined;
  /** Maximum number of days between booking and ticketing; empty if no restriction is defined. */
  maxTicketingAfterBooking: number | undefined;
  /** Minimum number of days between ticketing and departure; empty if no restriction is defined. */
  minTicketingBeforeDeparture: number | undefined;
  /** Defines whether a ticket can be deposited at the airport. */
  ticketOnDepInfo: string | undefined;
  /** Defines if the supplier do the ticketing. */
  ticketBySupplier: boolean | undefined;
}

export interface FareTypeInformation {
  originalFareType: string;
  salesPreferenceDisplayName: string | undefined;
  salesPreferencePriority: number | undefined;
  agentCompanyID: string | undefined;
  /** Only filled if the FareType is set to  “WebFare”  */
  agentID: string | undefined;
  /** Only filled if the FareType is set to  “CorporateFare” */
  corporateCode: string | undefined;
  /** Parameter to specify the sub fare type of NEGO fares and CORPorate fares. Possible values are:
Normal: Standard corporate or nego fares.
Preferred: Preferred corporate or nego fares. */
  fareSubType: FareSubTypeEnum | undefined;
  /** The type of the fare. This value occurs only once.Available values are:
            Unknown
            NetFare
            PublishedFare
            NegoFare
            CorpFare
            WebFare
            CharterFare
            MixedFares */
  fareType: QueryFareTypeEnum | undefined;
  /** Flag to indicate if the fare is a percentage fare. */
  isPercentage: boolean | undefined;
}

export interface TravelHeaderMin {
  flightTime: string | undefined;
  groundTime: string | undefined;
  travelTime: string | undefined;
}

export enum FareSubTypeEnum {
  None = 1,
  Normal = 2,
  Preferred = 4,
}

export enum QueryFareTypeEnum {
  Unknown = 1,
  NetFare = 2,
  PublishedFare = 4,
  NegoFare = 8,
  CorpFare = 16,
  WebFare = 32,
  CharterFare = 64,
  MixedFares = 128,
}

export interface AvailableFareConnectionModel {
  index: number;
  availString: string | undefined;
  connectionIdentifier: ConnectionIdentifier | undefined;
  connectionHeader: ConnectionHeaderView | undefined;
  segments: AvailableFareSegmentModel[];
}

/** Object to identify a connection in a AvailableFares Result. All Indexes are 0-based. */
export interface ConnectionIdentifier {
  /** The ID of the AvailableFares Result. */
  fareResultID: string;
  /** Index of the Fare in the AvailableFares Result. */
  fareIndex: number;
  /** Leg Index in the Fare. */
  legIndex: number;
  /** Connection Index of the Leg. */
  connectionIndex: number;
}

export interface ConnectionHeaderView {
  departure: string | undefined;
  departureFullName: string | undefined;
  arrival: string | undefined;
  arrivalFullName: string | undefined;
  departureDate: string | undefined;
  departureDisplayTime: string | undefined;
  arrivalDate: string | undefined;
  arrivalDisplayTime: string | undefined;
  legTravelTime: TravelTimeView;
  travelStopps: number;
  via: Airport[] | undefined;
  viaToolTipContent: string | undefined;
  dayIndicator: string | undefined;
}

interface Carrier {
  code: string;
  hyperlink: string;
  hint: string;
  allianceCode: string;
  allianceName: string;
}

export interface Flight {
  allotmentInformation: any;
  arrivalAirport: Airport;
  arrivalDate: string;
  arrivalTerminal: string;
  bookingClass: string;
  brandCode: string;
  brandName: string;
  cabinClassCode: string;
  cabinClassName: string;
  carrier: Carrier;
  codeShare: any;
  datePairs: any[];
  departureAirport: Airport;
  departureDate: string;
  departureTerminal: string;
  equipmentCode: string;
  equipmentName: string;
  farebase: string;
  fareType: string;
  flightNumber: string;
  freeBaggageAllowance: string;
  freeBaggageDetails: any;
  freeSeats: number;
  includedServices: any[];
  mctExceeded: boolean;
  mealCode: string;
  numberOfStops: number;
  securedFlight: boolean;
  segmentID: string;
  segmentMileage: number;
  subFareType: string;
  surcharge: any;
  totalSeats: any;
  travelTime: string;
  index: number;
  dayIndicator: string;
  hasFreeBaggage: boolean;
}

export interface TravelTimeView {
  daysStayOver: number;
  hours: number;
  minutes: number;
  addHours: number;
}

export interface AvailableFareSegmentModel {
  allotmentInformation: SegmentAllotmentInformation | undefined;
  arrivalAirport: Airport;
  arrivalDate: Date | undefined;
  arrivalTerminal: string;
  bookingClass: string;
  brandCode: string;
  brandName: string;
  cabinClassCode: string;
  cabinClassName: string;
  carrier: Airline;
  codeShare: Airline | undefined;
  datePairs: DatePairModel[];
  departureAirport: Airport;
  departureDate: Date | undefined;
  departureTerminal: string;
  equipmentCode: string;
  equipmentName: string;
  farebase: string;
  fareType: string;
  flightNumber: string;
  freeBaggageAllowance: string;
  freeBaggageDetails: FreeBaggageAllowanceDetailsModel | undefined;
  freeSeats: number | undefined;
  includedServices: InludedServiceMainGroup[];
  mctExceeded: boolean | undefined;
  mealCode: string;
  numberOfStops: number | undefined;
  securedFlight: boolean | undefined;
  segmentID: string;
  segmentMileage: number | undefined;
  subFareType: string;
  surcharge: SharedPriceModel | undefined;
  totalSeats: number | undefined;
  travelTime: string;
  index: number;
  dayIndicator: string | undefined;
  hasFreeBaggage: boolean;
}

export interface SegmentAllotmentInformation {
  types: string[];
  affiliateCode: string;
  id: string;
  manatoryPrograms: boolean;
  matchCode: string | undefined;
  programs: string[];
  remark: string;
  supplierField: string;
}

export interface DatePairModel {
  allotmentID: string | undefined;
  arrivalDate: Date | undefined;
  bookingClass: string | undefined;
  departureDate: Date | undefined;
}

export interface FreeBaggageAllowanceDetailsModel {
  adult: string | undefined;
  child: string | undefined;
  infant: string | undefined;
}

export interface InludedServiceMainGroup {
  type: IncludedServiceMainType;
  label: string | undefined;
  services: IncludedServiceData[] | undefined;
}

export enum IncludedServiceMainType {
  Baggage = 0,
  Seat = 1,
  Meal = 2,
  Miles = 3,
  Transfer = 4,
  InFlightEntertainment = 5,
  Other = 6,
}

export interface IncludedServiceData {
  type: IncludedServiceMainType;
  subType: IncludedServiceSubType;
  hint: string | undefined;
}

export enum IncludedServiceSubType {
  Other = 0,
  Pet = 1,
  Security = 2,
  PriorityBoarding = 3,
  Ticket = 4,
  CheckIn = 5,
  ReBooking = 6,
  ChangeAfterDeparture = 7,
  ChangeBeforeDeparture = 8,
  FastTrack = 9,
  PriorityCheckIn = 10,
  RefundAllowed = 11,
  ChangeInCaseOfNoShow = 12,
  OpenReturnDate = 13,
  Stopover = 14,
  FreeBaggageAllowance = 15,
  CarryOnBaggage = 16,
  Lunch = 17,
  Snack = 18,
  SnacksAndBeverage = 19,
  ComplimentaryFoodAndBev = 20,
  NonAlcoholicDrink = 21,
  FreeAlcoholicDrink = 22,
  OtherSeat = 23,
  MilesAccrual = 24,
  OtherMiles = 25,
  PersonalEntertainment = 26,
  InternetAccess = 27,
  InSeatpower = 28,
}

export interface SharedPriceModel {
  currencyCode: string;
  isIATA: boolean;
  isIATASpecified: boolean;
  value: number;
  valueSpecified: boolean;
}

export interface FareAPISRequirements {
  none: boolean;
  password: boolean;
  passportNumber: boolean;
  creditCardForCheckIn: boolean;
  dob: boolean;
  apisDuringBooking: boolean;
  apisAfterBooking: boolean;
  paxNationality: boolean;
  sameBagsForAllLegs: boolean;
  genderRequired: boolean;
  municipalityForPassportRequired: boolean;
  fullAPISPassportInformation: boolean;
}

export interface LegSupportedFunctions {
  cancelSegment: boolean;
  cancelEntireBooking: boolean;
  getPNRFunction: boolean;
  rebooking: boolean;
  noEmailConfirmation: boolean;
  cancelPassenger: boolean;
  frequentFylerProgram: boolean;
  seatSelection: boolean;
  bookingOnHoldWithAutoCancel: boolean;
  bookingOnHoldWithAutoConfirm: boolean;
  optionBooking: boolean;
}

export interface FareHeaderView {
  cabinClassCombined: string[] | undefined;
  includedServices: InludedServiceMainGroup[] | undefined;
  fareHasFreeBaggage: boolean;
}

export interface FareInfoBoxView {
  salesPreferencePriority: number | undefined;
  queryGDS: string | undefined;
  bookingGDS: string | undefined;
  queryGDS_BookingGDSDisplayResult: string | undefined;
  lastTicketingDate: Date | undefined;
  queryPccs: string[] | undefined;
  bookingPccs: string[] | undefined;
  sources: string[] | undefined;
}

export interface FareTicketGroupOptions {
  ticketGroupID: string | undefined;
  legIndexes: number[] | undefined;
  bookOnHoldOptions: BookOnHoldOptions | undefined;
}

export interface BookOnHoldOptions {
  bookOnHoldPossible: boolean;
  canAutoConfirm: boolean;
  canAutoCancel: boolean;
  canOptionBooking: boolean;
  hasMaxHoldTime: boolean;
  maxHoldTime: string | undefined;
}

export interface Calculation_Result {
  totals: CalculationRow_Complete | undefined;
  calculationsByPassengerType: CalculationRow_Complete[] | undefined;
  displaySettings: CalculationRow_DisplaySettings | undefined;
  additionals: CalculationAdditionals[] | undefined;
}

export interface CalculationRow_Complete {
  passengerAmount: number;
  passengerType: string | undefined;
  rawValues: CalculationRow_RAW | undefined;
}

export interface CalculationRow_RAW {
  gross: number;
  gross_PerPerson: number;
  gross_AgencyServiceFee: number;
  gross_AgencyServiceFee_PerPerson: number;
  net: number;
  net_PerPerson: number;
  net_ConsolidatorServiceFee: number;
  net_ConsolidatorServiceFee_PerPerson: number;
  netNet: number;
  netNet_PerPerson: number;
  taxes: number;
  taxes_PerPerson: number;
  qSurcharge: number;
  qSurcharge_PerPerson: number;
  total: number;
}

export interface CalculationRow_DisplaySettings {
  show_Gross_AgencyServiceFee: boolean;
  showNet: boolean;
  show_Net_ConsolidatorServiceFee: boolean;
  showNetNet: boolean;
  showQSurcharge: boolean;
  enableCalculationDebugger: boolean;
  grossDisplayName: string | undefined;
  netDisplayName: string | undefined;
  netNetDisplayName: string | undefined;
  qSurchargeDisplayName: string | undefined;
}

export interface CalculationAdditionals {
  type: string;
  text: string;
  code: string;
  eqvivalentTotalPrice: number;
  amount: number;
}

export interface FareBookingPassengerView {
  /** Indicates if the Date of Birth was submitted during the search and cannot change during the booking process. */
  dateOfBirthLocked: boolean;
  bookingData: FareBookingInputPassengerModel;
  originalPassengerAbbrevation: string;
  originalPassengerTypeDisplayName: string;
  resultPassengerAbbrevation: string;
  resultPassengerDisplayName: string;
  passengerTypeIndex: number;
  isChild: boolean;
  isInfant: boolean;
  isAdult: boolean;
}

export interface FareBookingInputPassengerModel {
  /** Passenger type code, e.g. ADT,CHD... The returned Passenger type codes from the Fare response must be used. */
  passengerType: string;
  assistanceRequired: boolean;
  title: string | undefined;
  firstName: string;
  middleName: string | undefined;
  lastName: string;
  gender: AgentGenderEnum;
  /** This field should not be used anymore and will be removed in an later update. Use the OptionalDateOfBirth property instead. Do NOT set both dates. */
  dateOfBirth: Date | undefined;
  optionalDateOfBirth: InvariantDateModel | undefined;
  familyCertification: string | undefined;
  isMainPassenger: boolean;
  formOfIdentification: FarebookingFormOfIdentifikationModel | undefined;
  apis: FareBookingPassengerApis | undefined;
  ancillaries: AncillarySegmentBookRequest[] | undefined;
  frequentFlyerCards: BonusProgramModel[] | undefined;
}

export interface FarebookingFormOfIdentifikationModel {
  documentType: AgentFormOfIdentificationDocumentType;
  documentID: string;
  issuer: string;
  carrierCode: string;
}

export enum AgentFormOfIdentificationDocumentType {
  CreditCard = 0,
  FrequentFlyerNumber = 1,
  Passport = 2,
  DriversLicense = 3,
  LocalDefinedIDNumber = 4,
  NationalDefinedIDNumber = 5,
}

export interface FareBookingPassengerApis {
  passport: FareBookingPassengerApisPassport | undefined;
  visa: FareBookingPassengerApisVisa | undefined;
  address: FareBookingPassengerApisAddress | undefined;
}

export interface FareBookingPassengerApisPassport {
  type: AgentApisPassportType;
  nationality: string;
  country: string;
  expiryDate: InvariantDateModel | undefined;
  issueDate: InvariantDateModel | undefined;
  number: string;
  placeOfBirth: string;
  holder: boolean;
}

export enum AgentApisPassportType {
  Unkown = 0,
  ApprovedID = 1,
  Crewmember = 2,
  IDCardA = 3,
  IDCardC = 4,
  IDCardI = 5,
  PassportCard = 6,
  PassengerPassport = 7,
  MilitaryID = 8,
}

export interface FareBookingPassengerApisVisa {
  type: AgentApisVisaType;
  appliedCountry: string;
  dateOfIssue: InvariantDateModel | undefined;
  number: string;
  placeOfIssue: string;
}

export enum AgentApisVisaType {
  Unknown = 0,
  Visa = 1,
  Redress = 2,
  KnownTraveller = 3,
}

export interface FareBookingPassengerApisAddress {
  type: AgentApisAdressType;
  street: string;
  zip: string;
  city: string;
  state: string;
  country: string;
  municipality: string;
}

export enum AgentApisAdressType {
  Unknown = 0,
  Destination = 1,
  Residence = 2,
}

export interface AncillarySegmentBookRequest {
  segments: AncillarySegmentIdentifier[];
  bookingCode: string;
  carrierCode: string | undefined;
  date: Date | undefined;
  location: string | undefined;
  text: string | undefined;
  bookingType: ServiceBookingTypeEnumModel;
  id: string | undefined;
  extensions: string | undefined;
  serviceType: AncillaryTypeEnumModel;
}

export interface AncillarySegmentIdentifier {
  departure: string;
  arrival: string;
}

export enum ServiceBookingTypeEnumModel {
  None = 0,
  SSR = 1,
  SVC = 2,
  Seat = 3,
}

export enum AncillaryTypeEnumModel {
  None = 1,
  Baggage = 2,
  Seat = 4,
  Meal = 8,
  Transfer = 16,
  Other = 32,
  Mileage = 64,
  Change = 128,
  Upgrade = 256,
  CarryOnBaggage = 512,
  SpecialBaggage = 1024,
  Pet = 2048,
  OnBoardService = 4096,
  WIFI = 8192,
  Lounge = 16384,
  Drink = 32768,
  TravelService = 65536,
}

export interface DefaultAvailFaresfilterSettings {
  defaultOpenBar: boolean;
}

/** Request object for an available fares query. */
export interface AvailableFaresSearchRequest {
  /** If set to true, the search will consider the cabin classes set in the Segments, otherwise it will apply the Cabinclasses request object for all legs. */
  cabinClassPerLeg: boolean;
  /** The segments for which will be searched. */
  segments: FlightDetailSelection[];
  /** When set to true, will only return flights without stop. */
  directFlightsOnly: boolean;
  /** Sets the cabin classes for the request for ALL legs, if the CabinClassPerLeg property is set to true. Otherwise the Cabinclasses set in the Segments will be used. */
  cabinClasses: CabinClassInput;
  includeAirlines: string[];
  excludeAirlines: string[];
  passengers: AvailableFaresPassengerInput;
  overrideMultiChannelBranch: string | undefined;
  overrideMultiChannelBranchgroup: string | undefined;
  discountCode: string;
  islandResident: boolean;
  generalLargeFamily: boolean;
  specialLargeFamily: boolean;
}

export interface Idestination {
  iataCode: string,
  cityCode: string,
  allAirports: boolean,
  Destination?: string
}

export interface FlightDetailSelection {
  from: string | undefined;
  departure: AirportInfo;
  to: string | undefined;
  arrival: AirportInfo;
  radius: number;
  /** This field should not be used anymore and will be removed in an later update. Use the DepartureDate property instead. Do NOT set both dates. */
  date: Date | undefined;
  departureDate: InvariantDateModel | undefined;
  /** Sets the Cabinclasses for this leg. Will only be used if CabinClassPerLeg is set to false in parent. */
  cabinClasses: CabinClassInput | undefined;
}

export interface AirportInfo {
  iataCode: string,
  cityCode: string,
  allAirports: boolean
}

export interface AvailableFaresPassengerInput {
  adultPassengers: AvailableFaresPassengerTypeInput | undefined;
  childPassengers: AvailableFaresPassengerTypeInput | undefined;
  infantPassengers: AvailableFaresPassengerTypeInput | undefined;
}

export interface AvailableFaresPassengerTypeInput {
  passengerType: string;
  passengers: AvailableFaresPassengerTypeInputDetails[];
}

export interface AvailableFaresPassengerTypeInputDetails {
  /** This field should not be used anymore and will be removed in an later update. Use the OptionalDateOfBirth property instead. Do NOT set both dates. */
  dateOfBirth: Date | undefined;
  optionalDateOfBirth: InvariantDateModel | undefined;
  frequentFlyerCards: BonusProgramModel[] | undefined;
}

export interface MultiChannelRuleInfoModel {
  exclude: boolean | undefined;
  branch: string;
  branchgroup: string;
  ruleID: string;
  ruleName: string;
}

/** An object to describe the Validation State of an submitted Request. */
export interface InputValidationResult {
  /** Indicates if the input had invalid or missing fields. */
  isValid: boolean;
  /** An summary of all errors. */
  errorSummary: string[];
  /** Anb dictionary containing invalid fields. The keys depend on the submitted Request object. */
  propertyErrors: { [key: string]: string };
}

export interface BaseApiResponseMetaData {
  errorOccured: boolean;
  errorReason: TransactionInfo | undefined;
  requestTitle: string;
  transactionID: string;
  requestReceivedTime: Date;
  responseSentTime: Date;
  sessionID: string;
  userName: string;
  branchName: string;
  branchgroupName: string;
  webName: string;
  flightAPINode: string;
  transactions: TransactionInfo[];
  environment: string;
}

export interface TransactionInfo {
  errorCode: string;
  title: string;
  success: boolean;
  errorMessage: string;
  source: string;
  startTime: Date;
  endTime: Date;
  details: string;
}

export interface GetAvailableFaresApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: AvailableFareResultModel | undefined;
}

export interface FlightDetailsApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: DetailedAvailableFareTicketGroupsModel | undefined;
}

export interface DetailedAvailableFareTicketGroupsModel {
  totalTravelTime: string | undefined;
  detailedTicketGroups: DetailedAvailableFareTicketgroupModel[];
}

export interface DetailedAvailableFareTicketgroupModel {
  ticketGroupID: string;
  totalTravelTime: string | undefined;
  transactionID: string | undefined;
  errorMessage: string | undefined;
  legs: DetailedAvailableFareLeg[];
}

export interface DetailedAvailableFareLeg {
  selectedConnectionIndex: number;
  legIndex: number;
  carrier: Airline;
  header: AvailableFareLegAddionalInformationModel | undefined;
  segments: FlightDetailSegment[];
}

export interface AvailableFareLegAddionalInformationModel {
  flightTime: string;
  groundTime: string;
  travelTime: string;
  travelStops: string;
}

export interface FlightDetailSegment {
  segmentIndex: number;
  /** Additional Flight details for segment. Is null if source of segment is Web based. */
  additionalInformation:
  | AvailableFareSegmentAddionalInformationModel
  | undefined;
  baseSegment: AvailableFareSegmentModel;
}

export interface AvailableFareSegmentAddionalInformationModel {
  daysOfOperation: string[];
  onTime: string;
}

export interface AvailableFareSelectionRequestModel {
  /** Object to identify a cached fare result. */
  fareIdentifier: FareIdentifier;
  /** Indizes of selected connections in fare legs. 0-based. Must be equal to the amount of legs in the fare result. */
  selectedLegConnections: number[];
}

export interface GetAncillariesApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: AncillaryModel | undefined;
}

export interface AncillaryModel {
  passengers: ServicePassengerModel[];
  segments: ServiceSegmentModel[];
  services: ServiceModel[];
  prices: ServicePriceModel[];
}

export interface ServicePassengerModel {
  dateOfBirth: Date | undefined;
  firstName: string;
  id: string;
  lastName: string;
  number: number | undefined;
  typeLabel: string;
  typeAbbr: string;
}

export interface ServiceSegmentModel {
  arrival: string;
  arrivalTime: string;
  arrivalDate: Date | undefined;
  carrierCode: string;
  departure: string;
  departureDate: Date | undefined;
  departureTime: string;
  fareBase: string;
  flightNumber: string;
  id: string;
  number: number | undefined;
}

export interface ServiceModel {
  bookingType: ServiceBookingTypeEnumModel;
  bookingCode: string;
  code: string;
  extensions: string;
  id: string;
  text: string;
  emdRequired: boolean | undefined;
  freeTextFormat: string;
  freeTextMode: ServiceTextEnumModel;
  lastEMDDate: Date | undefined;
  referenceIDs: ServiceReferenceIDModel[];
  refundable: boolean | undefined;
  type: ServiceGroupTypeEnumModel;
  serviceCarrier: string;
  serviceDescription: string;
  serviceLocation: string;
  serviceType: AncillaryTypeEnumModel;
}

export enum ServiceTextEnumModel {
  None = 0,
  Optional = 1,
  Mandatory = 2,
}

export interface ServiceReferenceIDModel {
  frequentFlyerAirline: string;
  frequentFlyerNumber: string;
  passengerID: string;
  priceID: string;
  segmentIDs: string[];
}

export enum ServiceGroupTypeEnumModel {
  Baggage = 0,
  Seat = 1,
  Meal = 2,
  Transfer = 3,
  Other = 4,
}

export interface ServicePriceModel {
  equivalentPrice: SharedPriceModel | undefined;
  priceID: string;
  priceName: string;
  priceRemark: string;
}

export interface AvailFaresConnectionCalcDebugDetailsApiResponse
  extends BaseApiResponse {
  result: AvailFaresConnectionCalcDebugDetails | undefined;
}

export interface AvailFaresConnectionCalcDebugDetails {
  calculatedResult: CalculationResultModel[];
}

export interface CalculationResultModel {
  calculationDebugPaxInfo: DebugPaxDataModel[];
  calculationInput: InputDataModel | undefined;
  calculationItems: CalculationDetailsModel[];
}

export interface DebugPaxDataModel {
  debugInfo: DebugDataModel[];
  passengerType: string;
}

export interface DebugDataModel {
  guid: string;
  invalidityReason: string;
  isValid: boolean | undefined;
  position: number | undefined;
}

export interface InputDataModel {
  branch: string;
  branchGroup: string;
  level: number;
  levelTitle: string;
  web: string;
}

export interface CalculationDetailsModel {
  calculationFunctionName: string;
  calculationPath: string;
  dob: Date | undefined;
  equivalentInputPrice: SharedPriceModel | undefined;
  equivalentOutputPrice: SharedPriceModel | undefined;
  equivalentTax: number | undefined;
  errorMessage: string;
  originalInputPrice: SharedPriceModel | undefined;
  originalOutputPrice: SharedPriceModel | undefined;
  passengerType: string;
}

export interface GetRuleTextApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: RuleTextResponseDataView | undefined;
}

export interface RuleTextResponseDataView {
  rules: RuleChapterView[];
}

export interface RuleChapterView {
  ruleHeader: string;
  ruleLines: string[];
}

export interface SmartBookingApiResponse extends BaseApiResponse {
  result: FareBookingResponseModel | undefined;
}

export interface FareBookingResponseModel {
  /** Contains information if the submitted request was valid.  */
  validationResult: InputValidationResult;
  /** If the validation was successfull, this object will contain the information about the booking. If the validation failed, this object will be null. */
  result: SmartBookResponseDataModel | undefined;
}

export interface SmartBookResponseDataModel {
  totalPrice: SharedPriceModel | undefined;
  shoppingCartID: string;
  usedBookingRuleID: string;
  bookings: SmartBookResponseModel[];
}

export interface SmartBookResponseModel {
  requestedGroupID: string;
  bookingResponse: BookResponseDataModel | undefined;
  raisedException: RaisedExceptionModel | undefined;
  usedActions: SmartActionResponseModel[];
}

export interface BookResponseDataModel {
  additionalInformation: string[];
  bookingItemID: string;
  bookingOnHold: BookResponseBookingOnHoldModel | undefined;
  createdPayment: CreditCartDataModel | undefined;
  creditCardApprovalCode: string;
  customerLastName: string;
  customerReferenceNumber: string;
  equivalentTax: SharedPriceModel | undefined;
  equivalentTotalPrice: SharedPriceModel | undefined;
  isBookingOnHold: boolean | undefined;
  legs: BookResponseLegModel[];
  moduleInfo: FlightApiModuleResponseDataModel | undefined;
  notesAndInformation: string[];
  onlineCheckinLink: string;
  pnr: GetPnrResult | undefined;
  passengers: BookResponsePassengerModel[];
  paymentTokens: string[] | undefined;
  queue: string;
  recordCounter: string;
  recordLocator: string;
  responseInfo: FlightApiResponseInfoDetailsModel | undefined;
  session: string;
  shoppingCartID: string;
  source: string;
  specialDiscounts: DiscountResponseDataModel[];
  surcharge: BookResponseSurchargesModel | undefined;
  tax: SharedPriceModel | undefined;
  ticketOnDepartureInfo: string;
  totalPrice: SharedPriceModel | undefined;
  usedCRSProfile: CRSModel | undefined;
  usedEmailAddress: string;
  warnings: string;
  webFareConfirmationPage: string;
}

export interface BookResponseBookingOnHoldModel {
  surcharge: SharedPriceModel | undefined;
  equivSurcharge: SharedPriceModel | undefined;
  surchargeDeducted: boolean | undefined;
  onHoldTimeLimit: string;
}

export interface CreditCartDataModel {
  brand: string;
  cvc: string;
  cardHolderDescription: string;
  expiryMonth: number;
  expiryYear: number;
  number: string;
  virtualCCReference: string | undefined;
}

export interface BookResponseLegModel {
  segments: BookResponseSegmentModel[];
  seatPreferences: boolean | undefined;
  tariffMatchCode: string;
}

export interface BookResponseSegmentModel {
  allotmentConfig: SegmentAllotmentInformation | undefined;
  arrival: Airport;
  arrivalDate: Date | undefined;
  bookingClass: string;
  brandCode: string;
  brandName: string;
  carrier: Airline;
  departure: Airport;
  departureDate: Date | undefined;
  flightNumber: string;
  includedServiceIDs: string[];
  segmentStatus: string;
  segmentNumber: string;
}

export interface FlightApiModuleResponseDataModel {
  moduleListenPort: string;
  moduleMachineName: string;
  moduleTransactionID: string;
  moduleVersion: string;
}

export interface GetPnrResult {
  freeTextResult: string;
  generalInfos: PNRResponseGeneralInfoModel;
  contacts: SingleBookingContact[];
  enhancedRemarks: EnhancedRemarkModel[];
  infos: PNRResponseInfoModel[];
  locations: PnrResponseLocationModel[];
  osiElements: PnrResponseOSIModel[];
  passengers: PnrResponsePassengerModel[];
  payments: PnrResponsePaymentModel[];
  phones: PnrResponsePhoneModel[];
  skElements: PnrResponseSKElementModel[];
  ssrElements: PnrResponseSSRModel[];
  segments: PnrResponseSegmentModel[];
  services: PNRServiceDataModel[];
  specialDiscounts: DiscountResponseDataModel[];
  storedFares: PnrResponseStoredFareModel[];
  storedServices: PnrServiceFareDataModel[];
  ticketInfo: PnrResponseTicketInfoModel[];
  ticketedSevices: TicketedServiceDataModel[];
  ticketingDates: TicketingDateTypeDataModel[];
}

export interface PNRResponseGeneralInfoModel {
  backOffice: string;
  creatorAgent: string;
  creatorPCC: string;
  isGroupbooking: boolean | undefined;
  isTicketIssued: boolean | undefined;
  numberOfInfos: number | undefined;
  numberOfPhones: number | undefined;
  pointOfTurnAround: string;
  receivedFrom: string;
  securedFlight: boolean | undefined;
  source: string;
  ticketingDate: Date | undefined;
  ticketingDateType: string;
}

export interface SingleBookingContact {
  additionalStreet1: string;
  additionalStreet2: string;
  city: string;
  companyName: string;
  contactID: string;
  contactType: SingleBookingContactType;
  country: string;
  countryCode: string;
  firstName: string;
  gender: AgentGenderEnum;
  idCardNumber: string;
  idCardType: string;
  lastName: string;
  password: string;
  phoneNumbers: SingleBookingContactPhone[];
  region: string;
  street: string;
  title: string;
  zipCode: string;
  id: number;
}

export enum SingleBookingContactType {
  Unknown = 0,
  Contact = 1,
  Invoice = 2,
  PhoneOnly = 3,
  EmailOnly = 4,
}

export interface SingleBookingContactPhone {
  area: string;
  countryCode: string;
  number: string;
  type: SingleBookingContactPhoneType;
}

export enum SingleBookingContactPhoneType {
  Unknown = 0,
  Home = 1,
  Business = 2,
  Agent = 3,
  Mobile = 4,
  Fax = 5,
  Email = 6,
}

export interface EnhancedRemarkModel {
  passengerSelection: number[];
  remark: string;
  remarkType: RemarkTypeModelEnum;
  segmentSelection: number[];
  typeCode: string;
}

export enum RemarkTypeModelEnum {
  None = 0,
  General = 1,
  Historical = 2,
  Coded = 3,
  Confidential = 4,
  Itinerary = 5,
  Invoice = 6,
  Other = 7,
}

export interface PNRResponseInfoModel {
  bookingStatus: string;
  crs: string;
  createdDate: Date | undefined;
  pnrType: string;
  passengerNameRecordType: string;
  recordLocator: string;
  session: string;
  unknownPNRType: string;
}

export interface PnrResponseLocationModel {
  branchID: string;
  queue: string;
}

export interface PnrResponseOSIModel {
  carrier: string;
  text: string;
}

export interface PnrResponsePassengerModel {
  age: number;
  assistanceRequired: boolean;
  customerNameData: string;
  dateOfBirth: Date | undefined;
  equivalentPrice: SharedPriceModel | undefined;
  equivalentTax: SharedPriceModel | undefined;
  foid: FormOfIdentificationModel | undefined;
  firstName: string;
  frequentFlyerAirline: string;
  frequentFlyerNumber: string;
  name: string;
  nameRemark: string;
  originalPassengerNumber: string;
  osi: PnrResponseOSIModel[];
  passengerNumber: number;
  passengerType: string;
  passengerTypeCode: string;
  passengerTypeName: string;
  price: SharedPriceModel | undefined;
  remarks: string[];
  skElements: PnrResponseSKModel[];
  seatPreferences: PnrResponseSeatPreferrenceModel[];
  specialServiceRequests: PnrResponseSSRModel[];
  tax: SharedPriceModel | undefined;
  ticketNumbers: PNRResponseTicketNumberModel[];
  title: string;
}

export interface FormOfIdentificationModel {
  carrierCode: string;
  issuer: string;
  number: string;
  type: string;
}

export interface PnrResponseSKModel {
  code: string;
  text: string;
  segmentNumbers: number[];
}

export interface PnrResponseSeatPreferrenceModel {
  characteristics: string;
  chargeable: boolean;
  isIssued: boolean;
  preference: string;
  row: string;
  seat: string;
  segmentNumber: number[];
  status: string;
}

export interface PnrResponseSSRModel {
  chargeable: boolean;
  code: string;
  segmentNumbers: number[];
  passengerNumbers: number[];
  status: string;
  text: string;
  id?: string;
}

export interface PNRResponseTicketNumberModel {
  isEMD: boolean;
  platingCarrier: string;
  segmentNumbers: string[];
  ticketStatus: string;
  ticketnumber: string;
}

export interface PnrResponsePaymentModel {
  passengerNumbers: number[];
  segmentNumbers: number[];
  paymentText: string;
}

export interface PnrResponsePhoneModel {
  number: string;
  type: string;
}

export interface PnrResponseSKElementModel {
  carrier: string;
  text: string;
  keyword: string;
}

export interface PnrResponseSegmentModel {
  airline: Airline;
  airlineRecordLocator: string;
  allotment: SegmentAllotmentInformation | undefined;
  arrival: Airport;
  departureTerminal: string;
  arrivalTerminal: string;
  arrivalDate: Date | undefined;
  bookStatus: string;
  bookingClass: string;
  brandCode: string;
  brandName: string;
  cabinClass: string;
  checkInTime: Date | undefined;
  departure: Airport;
  departureDate: Date | undefined;
  equipmentName: string;
  fareTimeLimit: string;
  fareType: string;
  flightNumber: string;
  includedServiceIDs: string[];
  isAllotment: boolean;
  isElectronicTicketingPermitted: boolean;
  mealCode: string;
  mileages: string;
  operatingCarrier: string;
  operatingCarrierCode: string;
  originalSegmentNumber: number | undefined;
  segmentNumber: number;
  segmentStatus: string;
  allotmentCategory: number | undefined;
  allotmentID: string;
  bookingItemID: string;
  cartID: string;
  codeShare: string;
  corporateCode: string;
  extensions: string;
  farebase: string;
  fareCalculation: string;
  fareSelectionCurrency: string;
  freeBaggage: string;
  isRoundTrip: boolean | undefined;
  numberOfStops: number | undefined;
  requestedCurrency: string;
  secureDataNeeded: number | undefined;
  subFareType: number | undefined;
  travelTime: string;
}

export interface PNRServiceDataModel {
  carrierCode: string;
  chargeable: boolean;
  isIssued: boolean;
  passengerNumbers: number[];
  segmentNumbers: number[];
  serviceCode: string;
  serviceID: string;
  serviceText: string;
  status: string;
}

export interface DiscountResponseDataModel {
  code: string;
  discountID: string;
  text: string;
  passengerSelections: number[];
  segmentSelections: number[];
}

export interface PnrResponseStoredFareModel {
  fareDetails: PnrResponseFareDetailsModel | undefined;
  lastTicketingDate: Date | undefined;
  lastTicketingDateSpecified: boolean;
  number: number;
  numberSpecified: boolean;
  passengerNumber: number[];
  status: string;
  storedFareCreationDate: Date | undefined;
  storedFareCreationDateSpecified: boolean;
  taxes: PnrResponseTaxModel[];
  ticketingDetails: PnrResponseTicketingDetailsModel | undefined;
  ticketingSegments: PnrResponseStoredFareTKTSegmentModel[];
}

export interface PnrResponseFareDetailsModel {
  baseFare: SharedPriceModel | undefined;
  equivalentBaseFare: SharedPriceModel | undefined;
  fareCalculation: string;
  fareIssueID: string;
  grandTotal: SharedPriceModel | undefined;
  totalAmount: SharedPriceModel | undefined;
  totalFee: SharedPriceModel | undefined;
  totalTax: SharedPriceModel | undefined;
}

export interface PnrResponseTaxModel {
  status: string;
  action: string;
  actionSpecified: boolean;
  price: SharedPriceModel;
  type: string;
}

export interface PnrResponseTicketingDetailsModel {
  commission: string;
  endorsment: string;
  formOfPayment: string;
  originalIssuedDetails: string;
  tourcode: string;
  validatingCarrier: string;
}

export interface PnrResponseStoredFareTKTSegmentModel {
  designator: string;
  fareBase: string;
  freeBaggageAllowance: string;
  nva: string;
  nvb: string;
  number: number;
  numberSpecified: boolean;
  originalNumber: number;
  originalNumberSpecified: boolean;
  stopIndicator: string;
  ticketStatus: string;
}

export interface PnrServiceFareDataModel {
  coupons: PnrServiceFareCouponDataModel[];
  documentType: string;
  emdRequired: boolean;
  equivalentServicePrice: SharedPriceModel | undefined;
  extensions: string;
  fareCalculation: string;
  lastEMDDate: Date | undefined;
  passengerNumber: number | undefined;
  platingCarrier: string;
  serviceCode: string;
  serviceCreationDate: Date | undefined;
  serviceID: string;
  servicePrice: SharedPriceModel | undefined;
}

export interface PnrServiceFareCouponDataModel {
  bookingType: ServiceBookingTypeEnumModel;
  bookingTypeCode: string;
  bookingTypeID: string;
  bookingTypeText: string;
  carrier: string;
  exchangeable: boolean | undefined;
  extensions: string;
  lastEMDDate: Date | undefined;
  notValidAfter: Date | undefined;
  notValidBefore: Date | undefined;
  refundable: boolean | undefined;
  segmentNumber: number | undefined;
  serviceCode: string;
  serviceText: string;
}

export interface PnrResponseTicketInfoModel {
  baseFare: SharedPriceModel | undefined;
  dateOfIssuse: Date | undefined;
  dateOfIssuseSpecified: boolean;
  documentInfo: PnrResponseDocumentInfoModel[];
  equivalentBaseFare: SharedPriceModel | undefined;
  fareCalculation: string;
  firstName: string;
  formOfPaymentAmount: string;
  formOfPaymentType: string;
  grandTotal: SharedPriceModel | undefined;
  iataNumber: string | undefined;
  lastName: string;
  pointOfIssue: string;
  taxes: TaxDetailModel[];
  ticketStatus: string;
  totalAmount: SharedPriceModel | undefined;
  totalFee: SharedPriceModel | undefined;
}

export interface PnrResponseDocumentInfoModel {
  arrival: string;
  baggage: string;
  bookingClass: string;
  company: string;
  couponNumber: string;
  couponStatus: string;
  departure: string;
  documentDetails: string;
  fareBase: string;
  flightDate: Date | undefined;
  flightDateSpecified: boolean;
  flightInfo: string;
  nva: string;
  nvb: string;
  stopIndicator: string;
}

export interface TaxDetailModel {
  action: string;
  actionSpecified: boolean;
  price: SharedPriceModel;
  type: string;
}

export interface TicketedServiceDataModel {
  associatedTicketIDs: string[];
  coupons: ServiceTicketCouponDataModel[];
  dateOfIssue: Date | undefined;
  documentNumber: string;
  equivalentServicePrice: SharedPriceModel | undefined;
  fareCalculation: string;
  formOfPayment: string;
  iataNumber: string;
  passengerID: string;
  platingCarrier: string;
  pointOfIssue: string;
  servicePrice: SharedPriceModel;
  serviceText: string;
  status: string;
}

export interface ServiceTicketCouponDataModel {
  arrival: string;
  carrier: string;
  couponStatus: string;
  departure: string;
  documentNumber: string;
  documentType: string;
  extensions: string;
  notValidAfter: Date | undefined;
  notValidBefore: Date | undefined;
  refundable: boolean | undefined;
  serviceCode: string;
  serviceText: string;
}

export interface TicketingDateTypeDataModel {
  ticketingDate: Date | undefined;
  ticketingDateType: string;
}

export interface BookResponsePassengerModel {
  apisErrorCode: string;
  apisErrorText: string;
  dateOfBirth: Date | undefined;
  detailedTaxes: TaxDetailModel[];
  endorsement: string;
  equivalentPassengerFare: SharedPriceModel | undefined;
  equivalentTotalTax: SharedPriceModel | undefined;
  firstName: string;
  lastName: string;
  passengerFare: SharedPriceModel | undefined;
  passengerType: string;
  paymentMethods: DetailedPaymentMethodModel[];
  qSurcharge: SharedPriceModel | undefined;
  seatReservations: BookResponseSeatReservationModel[];
  ticketSegments: BookResponseTicketDataModel[];
  totalTax: SharedPriceModel | undefined;
  tourCode: string;
  type: string;
}

export interface DetailedPaymentMethodModel {
  bookingFee: SurchargeDataModel | undefined;
  creditCardCompanyCode: string;
  creditCardCompanyTitle: string;
  legSelection: number[];
  passengerType: string;
  passwordSupported: boolean | undefined;
  paymentFee: SurchargeDataModel | undefined;
  paymentType: string;
}

export interface SurchargeDataModel {
  amount: SharedPriceModel | undefined;
  equivalentAmount: SharedPriceModel | undefined;
  equivalentMinimumSurcharge: SharedPriceModel | undefined;
  isForEachPassenger: boolean | undefined;
  isForEachSegment: boolean | undefined;
  minimumSurcharge: SharedPriceModel | undefined;
  percentageSurcharge: string;
  percentageSurchargeContains: string;
  percentageSurchargeMinimum: SharedPriceModel | undefined;
}

export interface BookResponseSeatReservationModel {
  seatColumn: string;
  seatRow: string;
  segmentIndex: string;
}

export interface BookResponseTicketDataModel {
  farebase: string;
  freeBaggageAllowance: string;
  segmentNumbers: number[];
  ticketbySupplier: boolean | undefined;
  ticketDesignator: string;
  ticketNumber: string;
}

export interface FlightApiResponseInfoDetailsModel {
  apiVersion: string;
  exceptions: RaisedExceptionModel[];
  listenPort: string;
  machineName: string;
  responseDateTime: Date | undefined;
  transactionID: string;
}

export interface RaisedExceptionModel {
  crs: CRSModel | undefined;
  exceptionCode: string;
  exceptionText: string;
  extendedTransactionID: string;
  source: string;
  sourceIP: string;
}

export interface CRSModel {
  gds: string;
  guid: string;
  receivedFrom: string;
  terminalCountry: string;
  terminalPCC: string;
  user: string;
}

export interface BookResponseSurchargesModel {
  baggageSurcharge: SharedPriceModel | undefined;
  bookingSurcharge: SharedPriceModel | undefined;
  checkInSurcharge: SharedPriceModel | undefined;
  equivalentBaggageSurcharge: SharedPriceModel | undefined;
  equivalentBookingSurcharge: SharedPriceModel | undefined;
  equivalentCheckInSurcharge: SharedPriceModel | undefined;
  equivalentHandBaggageSurcharge: SharedPriceModel | undefined;
  equivalentPaymentSurcharge: SharedPriceModel | undefined;
  equivalentPrioritySurcharge: SharedPriceModel | undefined;
  equivalentSMSSurcharge: SharedPriceModel | undefined;
  equivalentSeatSurcharge: SharedPriceModel | undefined;
  handBaggageSurcharge: SharedPriceModel | undefined;
  paymentSurcharge: SharedPriceModel | undefined;
  prioritySurcharge: SharedPriceModel | undefined;
  smsSurcharge: SharedPriceModel | undefined;
  seatSurcharge: SharedPriceModel | undefined;
}

export interface SmartActionResponseModel {
  actionID: string;
  description: string;
  raisedException: RaisedExceptionModel | undefined;
}

export interface FareBookingSubmitModel {
  /** If available, setting this flag to false will result in a test booking. True will make a live booking. */
  isLiveBooking: boolean;
  /** GUID of the returned fares result. */
  fareResultID: string;
  /** Index of the fare in the returned fares result. */
  fareIndex: number;
  /** Container for the address where the ticket should be sent to. Will be ignored if Branch configuration is set to use Branch Adress. */
  adress: Adress | undefined;
  /** Optional Container for the Invoice address of the client. If this container is empty the content from Delivery Adress will be used */
  invoiceAdress: Adress | undefined;
  legIdentifiers: FareBookingLegIdentifier[];
  /** List of Passengers. The amount,Passengertypes and Birthdates must be equal to the returned Passengers in the fares result. */
  passengers: FareBookingInputPassengerModel[];
  /** Optional list of configurations for the returned ticket groups. Please refer to the returned fare object for available options. */
  ticketGroupOptions: FareBookingTicketGroupOptions[] | undefined;
  /** Additonal Input  */
  otherInput: FareBookingOtherInput | undefined;
  MultiChannelBranchGroup: string;
  MultiChannelBranch: string;
  UsedRuleName: string;
  DobHandling: number;
}


export interface FareRebookingSubmitModel {
  SegmentSelectionToBeReplaced: number[];
  bookingIdentifier: ReBookingIdentifier;
  Replacement: Replacement;
}

export interface Replacement {
  /** List of passengers for the replacement booking. */
  passengers: FareBookingInputPassengerModel[];
  /** Unique identifier for the fare result. */
  fareResultID: string;
  /** Index of the fare in the fare result. */
  fareIndex: number;
  /** Array of leg identifiers for the booking. */
  legIdentifiers: FareBookingLegIdentifier[];
  /** Optional configurations for ticket groups. */
  ticketGroupOptions: FareBookingTicketGroupOptions[] | undefined;
  /** Address details where the ticket should be sent. */
  adress: Adress | undefined;
  /** Additional input details such as passwords and emergency phone number. */
  otherInput: FareReBookingOtherInput | undefined;
  /** Flag indicating if the booking is live or a test. */
  isLiveBooking: boolean;
  /** Optional invoice address, if different from the delivery address. */
  invoiceAdress: Adress | undefined;
  /** Group associated with the booking for multi-channel distribution. */
  MultiChannelBranchGroup: string;
  /** Specific branch associated with the booking. */
  MultiChannelBranch: string;
  /** Rule name used during the booking process. */
  UsedRuleName: string;
  /** Handling code for date of birth. */
  DobHandling: number;
}

export interface FareBookingLegIdentifier {
  legIndex: number;
  connectionIndex: number;
}

export interface FareBookingTicketGroupOptions {
  ticketGroupID: string | undefined;
  bookingOnHoldSelection: FareBookingOnHoldEnum;
}

export enum FareBookingOnHoldEnum {
  NotApplicable = 0,
  Autocancel = 1,
  AutoConfirm = 2,
  OptionBooking = 3,
}

export interface FareReBookingOtherInput {
  emergencyPhone: string | undefined;
  webfarePassword: string | undefined;
}

export interface FareBookingOtherInput {
  emergencyPhone: string | undefined;
  webfarePassword: string | undefined;
  paymentBOFDetails: [] | any;
}

export interface UpdatedBookingApiResponse extends BaseApiResponse {
  warnings: string[];
  validationResult: AdminEntityValidationResult;
  updatedBooking: BookingItemModel;
}

export interface AdminEntityValidationResult {
  isValid: boolean;
  errorSummary: string[];
  properyErrors: { [key: string]: string };
}

export interface BookingItemModel {
  latestVersion: BookingVersionItemModel;
  historyItems: BookingVersionItemModel[] | undefined;
}

export interface BookingVersionItemModel {
  version: number;
  generalInfo: SingleBookingGeneralInfo;
  bookingIdentifier: BookingIdentifier;
  notifications: NotificationDataModel[];
  flightDetailsInfo: BookingFlightDetailsModel | undefined;
  allowedActions: AgentPlusBookingManagerFeature[];
}

export interface SingleBookingGeneralInfo {
  bookingDate: Date | undefined;
  bookingId: string;
  bookingStatus: BookingStatus;
  bookingType: BookingType;
  bookingUTC: number | undefined;
  bookingVersion: number | undefined;
  branch: string;
  branchgroup: string;
  cartId: string;
  creationDateTime: Date | null;
  destination: Airport;
  distributionChannel: string;
  totalPrice: SharedPriceModel | undefined;
  totalTax: SharedPriceModel | undefined;
  externalReference: string;
  firstDepartureDate: Date | undefined;
  lastArrivalDate: Date | undefined;
  mainPassengerFirstName: string;
  mainPassengerLastName: string;
  source: string;
  sourceCode: number;
  origin: Airport;
  platingCarrier: Airline;
  filekey: string;
  responsibleAgent: string;
  statusCode: string;
  ticketingDate: Date | undefined;
  ticketMethod: TicketOrderDataModel | undefined;
  ticketTimeLimit: Date | undefined;
  crs: CRSModel | undefined;
  paymentInfo: SingleBookingPaymentInfo | undefined;
  webAgent: string;
}

export enum BookingStatus {
  All = 0,
  Unknown = 0,
  Booked = 2,
  TicketingInProgress = 4,
  TicketIssued = 8,
  Canceled = 16,
  NotProcessed = 32,
  TicketedError = 64,
  BookingError = 128,
  CancelError = 256,
  Queued = 512,
  OrderReshop = 1024,
  OrderReshopFailed = 2048,
  TicketCanceled = 4096,
  TicketCancelError = 8192,
}

export enum eBookingStatus {
  Unknown = 0,
  Booked = 1,
  TicketingInProgress = 2,
  TicketIssued = 4,
  Canceled = 8,
  NotProcessed = 16,
  TicketedError = 32,
  BookingError = 64,
  CancelError = 128,
  Queued = 256,
  OrderReshop = 512,
  OrderReshopFailed = 1024,
  TicketCanceled = 2048,
  TicketCancelError = 4096,
}

export enum BookingType {
  Flight = 0,
  Hotel = 1,
  Cruise = 2,
  Car = 3,
}

export interface TicketOrderDataModel {
  enableBranchAccess: boolean | undefined;
  ticketCategory: string;
  ticketOrder: string;
  ticketPcc: string;
  ticketQueue: string;
}

export interface SingleBookingPaymentInfo {
  bankCodeNumber: string;
  bankName: string;
  creditCardExpiryDate: Date | undefined;
  creditCardType: string;
  holderName: string;
  number: string;
  paymentType: string;
  virtualPaymentProvider: string;
}

/** Object to identify a single booking. */
// export interface BookingIdentifier {
//   cartId: string;
//   bookingId: string;
//   emdSelection: string;
//   description?: string
//   emailIds?: string
//   passengerSelection?: string
//   replyAddress?: string
//   segmentSelection?: null
//   templateName?: string
// }

export interface ConfirmNotifications {
  BookingIdentifier: {
    CartId: string;
    BookingId: string;
  };
}


export interface BookingIdentifiers {
  cartId: string;
  bookingId: string;
}


export interface BookingIdentifier {
  cartId: string;
  bookingId: string;
  emailIds?: EmailIds;
  description?: string | null;
  passengerSelection?: number[]; // HHOPS-9664
  segmentSelection?: number[]; // HHOPS-9664
  emdSelection?: string[]; // HHOPS-10874
  replyAddress?: string;
}

export interface BookingIdentifierExtended extends BookingIdentifier {
  webId: string;
  branchGroupId: string;
  branchId: string;
}


export interface EmailIds {
  to: string[];
  cc: string[];
  bcc: string[];
  passengers: Passenger[];
  default?: boolean
}

export interface Passenger {
  name: string;
  email: string;
}



export interface BookingId {
  bookingId: string;
  version?: number;
}

export interface ReBookingIdentifier {
  cartId: string;
  bookingId: string;
  emailIds: null,
  description: null,
  templateName: null,
  passengerSelection: null,
  segmentSelection: null,
  emdSelection: null
}

export interface BookingIdentifierwithEmail {
  cartId: string;
  bookingId: string;
  emailIds: {};
  Description: string | null;
  TemplateName: string;
  replyAddress: string
}
export interface SendConfirmTicketResponse {
  status: boolean,
  message: string
}

interface NameChangeDetailsRequestModel {
  passengerBookingManagerID: string;
  newLastName: string;
  newFirstName: string;
  newDOB: string | undefined;
  newTitle: string;
  newGender: string | any;
  changeAPIS: boolean;
  changedStatusCode: number;
}

export interface NotificationDataModel {
  actionRequired: ENotificationActionRequiredEnumModel;
  branch: string;
  branchGroup: string;
  cartID: string;
  cartVersion: number | undefined;
  category: ENotificationCategoryEnumModel;
  confidential: boolean;
  extension: string;
  notificationID: string;
  readOnly: boolean;
  source: ENotificationSourceEnumModel;
  status: ENotificationStatusEnumModel;
  text: string;
  timeStamp: Date | undefined;
  title: string;
  userName: string;
  version: number | undefined;
  web: string;
}

export interface b2cSettingsText {
  HotelTab: string | undefined;
  AirPortSearchType: string | undefined;
  ShowLanguageDecimalTabB2C: string | undefined;
  ShowExtraAncillariesTabB2C: string | undefined;
  ShowDateInput: string | undefined;
  ShowDefaultFilter: string | undefined;
  CabinClass: CabinClassInterface;
  TermsConditionsLink: string | undefined;
  ShowBackgroundModalColor: string;
  showMarqueeText: string | undefined;
  showMarqueeFrom: string | undefined;
  showMarqueeTo: string | undefined;
  showBrandName: string | undefined;
  showFilterPosition: string | undefined;
  priceOption: string | undefined;
  showAssistance: string | undefined;
  Style: string | undefined;
  ConfirmationText: string | undefined;
}


interface CabinClassInterface {
  [key: string]: {
    Checked: boolean;
    preSelect: boolean;
  };
}

export enum ENotificationActionRequiredEnumModel {
  None = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  Urgent = 4,
}

export enum ENotificationCategoryEnumModel {
  PaymentRejected = 0,
  OCN = 1,
  TTL = 2,
  Reprice = 3,
  Remark = 4,
  BookingFailed = 5,
  QueueRobot = 6,
  Other = 7,
}

export enum ENotificationSourceEnumModel {
  Extern = 0,
  Intern = 1,
}

export enum ENotificationStatusEnumModel {
  Unknown = 0,
  Created = 1,
  Modified = 2,
  Removed = 3,
  Failed = 4,
}

export interface BookingFlightDetailsModel {
  invoice: SingleBookingContact | undefined;
  delivery: SingleBookingContact | undefined;
  passengers: BookingItemPassengerModel[];
  legs: BookingManagementLeg[];
  passengerQuotes: BookingManagementPassengerQuote[];
  calculationResult: Calculation_Result;
  variousElements: BookingItemVariousElement[];
  skElements: PnrResponseSKElementModel[];
  ssrElements: PnrResponseSSRModel[];
  osiElements: PnrResponseOSIModel[];
  enhancedRemarks: EnhancedRemarkModel[];
  seats: BookingManagerSeatInfoModel[];
  services: BookingManagerServiceInfoModel[];
}

export interface BookingItemPassengerModel {
  firstName: string;
  lastName: string;
  birthDate: string;
  gender: AgentGenderEnum | null;
  passengerID: string;
  passengerNumber: number;
  type: string;
  ticketNumbers: BookingItemTicketNumberModel[];
}

export interface NameChangeRequestModel {
  passengerChanges: NameChangeDetailsRequestModel[];
  BookingIndentifier: BookingIdentifier;
}

export interface BookingItemTicketNumberModel {
  segmentNumbers: number[];
  ticketingCarrier: string;
  ticketNo: string;
  ticketStatus: number | undefined;
  ticketType: string;
}

export interface BookingManagementLeg {
  cabinClass: string;
  carrier: Airline;
  pointOfTurnaround: string;
  segments: PnrResponseSegmentModel[];
  calculationResults: CalculationResultModel[];
  appliedDiscounts: string;
}

export interface BookingManagementPassengerQuote {
  externalReference: string;
  fareQuote: BookingItemQuoteModel | undefined;
  passengerType: string;
  quoteSegmentIDs: string[];
  segmentNumbers: number[];
  payment: BookingItemPaymentModel | undefined;
  ticketInfos: BookingItemTicketModel[];
}

export interface BookingItemQuoteModel {
  baseFare: SharedPriceModel | undefined;
  equivalentBaseFare: SharedPriceModel | undefined;
  equivalentTotalFee: SharedPriceModel | undefined;
  equivalentTotalSurcharge: SharedPriceModel | undefined;
  equivalentTotalTax: SharedPriceModel | undefined;
  fareCalculation: string;
  taxDetails: TaxDetailModel[];
}

export interface BookingItemPaymentModel {
  paymentProvider: string;
  paymentType: string;
  storedPaymentID: string;
}

export interface BookingItemTicketModel {
  commission: string;
  designator: string;
  endorsement: string;
  farebase: string;
  fop: string;
  freeBaggageAllowance: string;
  nva: string;
  nvb: string;
  stopIndicator: string;
  tickettingTimeLimit: Date | undefined;
  tourcode: string;
}

export interface BookingItemVariousElement {
  bookedInVersion: number | undefined;
  bookingDate: Date | undefined;
  bookingItemID: string;
  bookingStatus: BookingStatus;
  carrierCode: string;
  cartID: string;
  code: string;
  equivalentPrice: SharedPriceModel | undefined;
  extensions: string;
  externalReference: string;
  passengerSelection: number[];
  price: SharedPriceModel | undefined;
  remarkType: RemarkTypeModelEnum;
  segmentSelection: number[];
  serviceDate: Date | undefined;
  serviceLocation: string;
  serviceQuantity: string;
  status: number | undefined;
  text: string;
  timeStamp: Date | undefined;
  type: AdvancedTypeEnum;
}

export enum AdvancedTypeEnum {
  Unknown = 0,
  SSR = 1,
  OSI = 2,
  SK = 3,
  SEAT = 4,
  REMARK = 5,
  SERVICE = 6,
}

export interface BookingManagerSeatInfoModel {
  seat: string;
  passengerSelection: number[];
  segmentSelection: number[];
}

export interface BookingManagerServiceInfoModel {
  code: string;
  text: string;
  carrier: string;
  passengerSelection: number[];
  segmentSelection: number[];
}

export enum AgentPlusBookingManagerFeature {
  None = 0,
  RefreshPnr = 1,
  CancelBooking = 2,
  OrderReshop = 4,
  VoidCancelTicket = 8,
  ManageServices = 16,
  ManageElements = 32,
  Seatmap = 64,
  TicketIssue = 128,
  RetrievePNR = 256,
  DownloadBackOfficeFile = 512,
  FAPICommunication = 1024,
  FareRules = 2048,
  SplitBook = 4096,
  SetBookingAsDeprecated = 8192
}

export enum AgentPlusBookingManagerColumns {
  None = 0,
  ID = 1,
  Type = 2,
  TypeCode = 4,
  TypeID = 8,
  TypeText = 16,
  Carrier = 32,
  Exchangeable = 64,
  Extensions = 128,
  LastEMDDate = 256,
  NVB = 512,
  NVA = 1024,
  Refundable = 2048,
  Segment = 4096,
  PassengerName = 8192,
  ServiceCode = 16384,
  ServiceText = 32768
}

export interface BookingManagementOverviewApiResponse extends BaseApiResponse {
  /** Result of the Request. Is null when a error occured. */
  result: BookingManagementModel | undefined;
}

export interface BookingManagementModel {
  bookings: BookingItemModel[] | undefined;
  totalShoppingCarts: number;
  currentShoppingCarts: number;
  pageAmount: number;
  appliedFilter: BookingMangerFilterRequestData | undefined;
}

export interface BookingMangerFilterRequestData {
  freeField: string | undefined;
  shoppingCartID: string | undefined;
  bookingItemID: string | undefined;
  recordLocator: string | undefined;
  mainTravellerLastName: string | undefined;
  origin: string | undefined;
  destination: string | undefined;
  branch: string | undefined;
  branchGroup: string | undefined;
  responsibleAgent: string | undefined;
  membershipMembers: string | undefined;
  firstDepartureDate: InvariantDateModel | undefined;
  firstDepartureDateTo: InvariantDateModel | undefined;
  lastArrvialDate: InvariantDateModel | undefined;
  lastArrvialDateTo: InvariantDateModel | undefined;
  distributionChannel: string | undefined;
  statusCode: string | undefined;
  transactionID: string | undefined;
  gds: string | undefined;
  pcc: string | undefined;
  bookingDateFrom: InvariantDateModel | undefined;
  bookingDateTo: InvariantDateModel | undefined;
  bookingStatus: BookingStatus;
  ticketTimeLimitFrom: InvariantDateModel | undefined;
  ticketTimeLimitTo: InvariantDateModel | undefined;
  ticketingDateFrom: InvariantDateModel | undefined;
  ticketingDateTo: InvariantDateModel | undefined;
  externalReference: string | undefined;
  web: string | undefined;
  airlineCodes: string | undefined;
  maxItems: number;
  itemsOffset: number;
  sortModifiers: ShoppingCartSortModifier[] | undefined;
  notificationActionRequired: ENotificationActionRequiredEnumModel;
}

export interface ShoppingCartSortModifier {
  field: AgentShoppingCartSort;
  ascDesc: AscDescEnum;
}

export enum AgentShoppingCartSort {
  MainTravellerName = 0,
  Origin = 1,
  Destination = 2,
  Branch = 3,
  BranchGroup = 4,
  ResponsibleAgent = 5,
  FirstDepartureDate = 6,
  FirstDepartureDateTo = 7,
  DistributionChannel = 8,
  StatusCode = 9,
  GDS = 10,
  PCC = 11,
  BookingDate = 12,
  BookingStatus = 13,
  TicketTimeLimit = 14,
  TicketingDate = 15,
  WEB = 16,
  PlatingCarrier = 17,
  NotificationActionRequired = 18,
}

export enum AscDescEnum {
  Ascending = 0,
  Descending = 1,
}

export interface BookingDetailsApiResponse extends BaseApiResponse {
  result: BookingItemModel | undefined;
}

export interface GetPNRApiResponse extends BaseApiResponse {
  result: GetPnrResult | undefined;
}

export interface GetCancelSurchargesApiResponse extends BaseApiResponse {
  result: QuerySurchargeResultModel | undefined;
}

export interface QuerySurchargeResultModel {
  surcharge: SurchargeDataModel | undefined;
  notApplicable: boolean;
}

export interface CancelBookingApiResponse extends BaseApiResponse {
  result: CancelBookingResultModel | undefined;
}

export interface CancelBookingResultModel {
  updatedBooking: BookingItemModel | undefined;
  validationResult: AdminEntityValidationResult;
  warnings: string[];
}

export interface CancelTicketApiResponse extends BaseApiResponse {
  result: CancelTicketResultModel | undefined;
}

export interface CancelTicketResultModel {
  tickets: CancelTicketResponseTicketModel[];
  updatedBooking: BookingItemModel | undefined;
  validationResult: AdminEntityValidationResult;
  warnings: string[];
}

export interface CancelTicketResponseTicketModel {
  emdNumber: string;
  errorText: string;
  firstTicketNumber: string;
  lastTicketNumber: string;
  recordLocator: string;
  statusCode: string;
}


export interface CancelSegmentsApiResponse extends BaseApiResponse {
  result: CancelTicketResultModel | undefined;
}

export interface CancelSegmentsResultModel {
  tickets: CancelTicketResponseTicketModel[];
  updatedBooking: BookingItemModel | undefined;
  validationResult: AdminEntityValidationResult;
  warnings: string[];
}

export interface BookingServicesManagementApiResponse extends BaseApiResponse {
  result: BookingItemServicesManagementModel | undefined;
}

export interface BookingItemServicesManagementModel {
  errorMessages: string[];
  segments: PnrResponseSegmentModel[];
  passengers: BookingItemServicePassengerModel[];
  addedServices: BookingItemAddedServiceModel[];
  availableServices: BookingAvailableServiceModel[];
  availableServicesPrices: ServicePriceModel[];
}

export interface BookingItemServicePassengerModel {
  firstname: string;
  lastname: string;
  id: number;
  fapiType: number;
  typeAbbr: string;
}

export interface BookingItemAddedServiceModel {
  price: SharedPriceModel | undefined;
  passengerID: number;
  bookingType: ServiceBookingTypeEnumModel;
  bookingTypeCode: string;
  bookingTypeID: string;
  bookingTypeText: string;
  carrier: string;
  exchangeable: boolean | undefined;
  extensions: string;
  lastEMDDate: Date | undefined;
  notValidAfter: Date | undefined;
  notValidBefore: Date | undefined;
  refundable: boolean | undefined;
  segmentNumber: number[];
  serviceCode: string;
  serviceText: string;
  addedServiceID: string;
}

export interface BookingAvailableServiceModel {
  bookingType: ServiceBookingTypeEnumModel;
  bookingCode: string;
  code: string;
  extensions: string;
  id: string;
  text: string;
  emdRequired: boolean | undefined;
  freeTextFormat: string;
  freeTextMode: ServiceTextEnumModel;
  lastEMDDate: Date | undefined;
  referenceIDs: BookingAvailableServiceReferenceIDModel[];
  refundable: boolean | undefined;
  type: ServiceGroupTypeEnumModel;
  serviceType: AncillaryTypeEnumModel;
  serviceCarrier: string;
  serviceDescription: string;
  serviceLocation: string;
}

export interface BookingAvailableServiceReferenceIDModel {
  referenceID: string;
  frequentFlyerAirline: string;
  frequentFlyerNumber: string;
  passengerID: number;
  priceID: string;
  segmentIDs: number[];
}

export interface BookingElementsManagementApiResponse extends BaseApiResponse {
  result: BookingItemElementsManagementModel | undefined;
}

export interface BookingItemElementsManagementModel {
  ssrOptions: BookingItemElementsSSROption[];
  airlineOptions: Airline[];
  segments: PnrResponseSegmentModel[];
  passengers: PnrResponsePassengerModel[];
  bookingSSRElements: PnrResponseSSRModel[];
  bookingOSIElements: PnrResponseOSIModel[];
  bookingRemarkElements: EnhancedRemarkModel[];
}

export interface BookingItemElementsSSROption {
  code: string;
  label: string;
}

export interface AddServiceToBookingRequestModel {
  services: BookingServiceRequestModel[] | undefined;
  ssrServices: SSRRequestDataModel[] | undefined;
  bookingIndentifier: BookingIdentifier;
}

export interface BookingServiceRequestModel {
  carrier: string | undefined;
  code: string | undefined;
  date: Date | undefined;
  location: string | undefined;
  passengerSelection: number[] | undefined;
  quantity: number | undefined;
  segmentSelection: number[] | undefined;
  text: string | undefined;
  serviceType: AncillaryTypeEnumModel;
  extensions: string | undefined;
  id: string | undefined;
}

export interface SSRRequestDataModel {
  carrierCode: string;
  code: string;
  freeText: string;
  passengerSelection: number[];
  segments: number[];
}

export interface AddElementsToBookingRequestModel {
  services: BookingServiceRequestModel[] | undefined;
  remarks: EnhancedRemarkModel[] | undefined;
  ssrServices: SSRRequestDataModel[] | undefined;
  osi: AddOSIRequest[] | undefined;
  passengerAPIS: AddPassengerAPISToBookingRequest[] | undefined;
  bookingIndentifier: BookingIdentifier;
}

export interface AddOSIRequest {
  carrierCode: string;
  freeText: string;
  passengerSelection: number[];
}

export interface AddPassengerAPISToBookingRequest {
  passengerNumber: number;
  apis: FareBookingPassengerApis | undefined;
  firstName: string;
  lastName: string;
  middleName: string;
  title: string;
  gender: AgentGenderEnum;
  dateOfBirth: InvariantDateModel | undefined;
}

export interface RemoveServiceFromBookingRequestModel {
  services: BookingServiceRequestModel[] | undefined;
  ssrServices: SSRRequestDataModel[] | undefined;
  seats: SeatCancelRequestModel[] | undefined;
  bookingIndentifier: BookingIdentifier;
}

export interface SeatCancelRequestModel {
  passenger: number;
  row: string | undefined;
  seat: string | undefined;
  segment: string | undefined;
}

export interface RemoveElementsFromBookingRequestModel {
  services: BookingServiceRequestModel[] | undefined;
  remarks: EnhancedRemarkModel[] | undefined;
  ssrServices: SSRRequestDataModel[] | undefined;
  osi: AddOSIRequest[] | undefined;
  bookingIndentifier: BookingIdentifier;
}

export interface ImportBookingModel {
  source: FareSourceEnumModel;
  filekey: string | undefined;
  gds: string | undefined;
  crsGUID: string | undefined;
  crsReceivedFrom: string | undefined;
  crsTerminalCountry: string | undefined;
  crsTerminalPCC: string | undefined;
  crsUser: string | undefined;
  corporateCode: string | undefined;
  distributionchannel: string | undefined;
  equivalentCurrencyCode: string | undefined;
  extensions: string | undefined;
  externalReference: string | undefined;
  fareSelectionCurrency: string | undefined;
  /** Optional. If not set, you current Branch will be used. */
  branch: string | undefined;
  /** Optional. If not set, you current Branchgroup will be used. */
  branchGroup: string | undefined;
  /** Optional. If not set, your current User will be used. */
  responsibleAgent: string | undefined;
  airlineCode: string | undefined;
  lastName: string | undefined
}

export enum FareSourceEnumModel {
  None = 1,
  IBESource = 2,
  WebSource = 4,
  CharterSource = 8,
  VayantSource = 16,
  GDSSource = 32,
  NFESource = 64,
}

export interface BookingManagerSalesReportRequestData
  extends BookingMangerFilterRequestData {
  seperator: string;
  dateFormat: string | undefined;
}

export interface DeleteNotificationModel {
  identifier: BookingIdentifier;
  notificationID: string;
}

export interface UpdateNotificationModel {
  identifier: BookingIdentifier;
  /** Leave empty to create a new Notification. */
  notificationID: string | undefined;
  readOnly: boolean;
  title: string | undefined;
  text: string | undefined;
  actionRequired: ENotificationActionRequiredEnumModel;
  branch: string | undefined;
  branchgroup: string | undefined;
  username: string | undefined;
  category: ENotificationCategoryEnumModel;
  confidential: boolean;
}

export interface GetFareDisplayApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: FareLightModel | undefined;
}

export interface FareLightModel {
  passengers: FareDisplayPassenger[] | undefined;
  fares: LightFare[] | undefined;
  filterMatrix: LightFareFilterMatrix | undefined;
}

export interface FareDisplayPassenger {
  abbrevation: string | undefined;
  displayName: string | undefined;
  amount: number;
}

export interface LightFare {
  id: string | undefined;
  currency: string | undefined;
  totalPrice: string | undefined;
  distributionChannel: string | undefined;
  departure: Airport | undefined;
  arrival: Airport | undefined;
  outbound: LightLeg | undefined;
  hasInbound: boolean;
  inbound: LightLeg | undefined;
  source: string | undefined;
  filterValues: string[] | undefined;
  passengerPrices: FareDisplayPassengerPrices[] | undefined;
}

export interface LightLeg {
  legType: LightLegType;
  routing: LightRouting | undefined;
  advancePurchaseInfo: LightAdvancePurchaseInfo | undefined;
  ruleInfo: LightRuleInfo | undefined;
  ticketInfo: LightTicketInfo | undefined;
  weekDays: string | undefined;
  fareSubType: string | undefined;
}

export enum LightLegType {
  Outbound = 0,
  Inbound = 1,
}

export interface LightRouting {
  departure: Airport | undefined;
  arrival: Airport | undefined;
  carrier: Airline | undefined;
  via: string | undefined;
  stop: string | undefined;
  bookingClass: BookingClassView | undefined;
  cabinClass: string | undefined;
  cabinClassPreview: string | undefined;
}

export interface BookingClassView {
  code: string | undefined;
  displayName: string | undefined;
}

export interface LightAdvancePurchaseInfo {
  firstBookingDate: string | undefined;
  lastBookingDate: string | undefined;
  firstTicketingDate: string | undefined;
  lastTicketingDate: string | undefined;
  minBookingBeforeDeparture: string | undefined;
  minTicketingBeforeDeparture: string | undefined;
  ticketDaysAfterBooking: string | undefined;
}

export interface LightRuleInfo {
  minStay: string | undefined;
  maxStay: string | undefined;
  cancellationBeforeAfterTicketing: string | undefined;
  minAge: string | undefined;
  maxAge: string | undefined;
  season: string | undefined;
  rebookable: string | undefined;
  tariffType: string | undefined;
}

export interface LightTicketInfo {
  tourCode: LightTicketTourCodeInfo[] | undefined;
}

export interface LightTicketTourCodeInfo {
  passengerType: string | undefined;
  tourCode: string | undefined;
}

export interface FareDisplayPassengerPrices {
  passenger: FareDisplayPassenger | undefined;
  matchFound: boolean;
  pricePerPassenger: string | undefined;
  tax: string | undefined;
  taxPerPassenger: string | undefined;
  totalPriceWithoutTaxes: string | undefined;
  totalTax: string | undefined;
  totalPriceWithTaxes: string | undefined;
  currency: string | undefined;
}

export interface LightFareFilterMatrix {
  airlines: Airline[] | undefined;
  faresByType: FilterMatrixAirlineInfo[] | undefined;
}

export interface FilterMatrixAirlineInfo {
  label: string | undefined;
  dataAttributeType: string | undefined;
  hasFares: boolean;
  bestFare: FilterMatrixPriceInfo | undefined;
  prices: FilterMatrixPriceInfo[] | undefined;
}

export interface FilterMatrixPriceInfo {
  rawPrice: number;
  hasMatch: boolean;
  fareID: string | undefined;
  formattedPrice: string | undefined;
  currency: string | undefined;
}

export interface FareDisplaySearchRequest {
  segments: FlightDetailSelection[];
  passengers: number[];
  cabinClasses: CabinClassInput;
  includeAirlines: string[];
  excludeAirlines: string[];
}

export interface GetAllotmentInfoApiResponse extends BaseApiResponse {
  /** Result of the request. Return null if an exception occured. */
  result: AllotmentInfoResponseModel | undefined;
}

export interface AllotmentInfoResponseModel {
  /** Collection of all items */
  allotmentInfoItems: AllotmentInfoDataModel[] | undefined;
  /** Container of the used allotment account. */
  usedAccount: AllotmentAccountModel | undefined;
}

export interface AllotmentInfoDataModel {
  /** The allotment ID from the Allotment database */
  allotmentID: number | undefined;
  /** Three letter airport/city code for arrival point */
  arrival: string | undefined;
  /** Two letter airline code */
  carrier: string | undefined;
  bookings: AllotmentBookingInfoModel[] | undefined;
  /** Three letter airport/city code for departure point */
  departure: string | undefined;
  /** Departure date of allotment flight */
  departureDate: Date | undefined;
  groupFilekey: string | undefined;
  /** Identifier of the Allotment.
ATTENTION: This parameter only appears if Allotment is set in the request */
  identifier: string | undefined;
  isActive: boolean | undefined;
  originallyAllotmentSeats: string | undefined;
  programNumbers: string[] | undefined;
  requestID: number | undefined;
  /** Container of the segment info */
  segments: AllotmentSegmentInfoModel[] | undefined;
  supplier: string | undefined;
  /** Allotment booking info */
  totals: AllotmentBookingInfoModel | undefined;
  /** Contains the category type of the allotment.
    None
    GroupbookingOnline
    GroupbookingOffline
    Bookingclass
    Virtual
    Negospace
    Prospective
    All */
  type: AllotmentTypeModel | undefined;
  ruleMatchCode: string | undefined;
}

export interface AllotmentBookingInfoModel {
  /** Total number of seats in the allotment. */
  allotmentSeats: number | undefined;
  /** Number of available seats in the allotment */
  availableSeats: number | undefined;
  /** Number of booked seats in the allotmemt */
  bookedSeats: number | undefined;
  /** The allotment booking classes. */
  bookingClass: string | undefined;
  /** The cabin class in the allotment */
  cabinClass: CabinClassInput | undefined;
  /** Number of canceled seats in the allotmemt */
  cancelledSeats: number | undefined;
  /** All used filekeys in the allotment */
  filekeys: AllotmentFilekeyInfoModel[] | undefined;
  /** Number of splitted seats. */
  splittedSeats: number | undefined;
}

export interface AllotmentFilekeyInfoModel {
  bookingDate: Date | undefined;
  bookingID: number | undefined;
  cancelMode: AgentCancelationModeEnum;
  cancelationDate: Date | undefined;
  filekey: string | undefined;
  nonRecycable: boolean | undefined;
  passengerInfos: AllotmentPassengerInfoModel[] | undefined;
  seats: number | undefined;
  splitted: boolean | undefined;
}

export enum AgentCancelationModeEnum {
  None = 0,
  Partial = 1,
  Full = 2,
}

export interface AllotmentPassengerInfoModel {
  cancellationDate: Date | undefined;
  dateOfBirth: Date | undefined;
  firstName: string | undefined;
  gender: AgentGenderEnum;
  insertedInGroupbooking: boolean | undefined;
  lastName: string | undefined;
  passengerType: string | undefined;
  tattoo: string | undefined;
  title: string | undefined;
}



interface DeprecateBookingResponse {
  result: {
    validationResult: {
      isValid: boolean;
      errorSummary: string[];
      properyErrors: Record<string, any>;
    };
    successful: boolean;
  };
  responseMetaData: {
    errorOccured: boolean;
    errorReason?: {
      errorCode: string;
      title: string;
      success: boolean;
      errorMessage: string;
      source: string;
      startTime: string;
      endTime: string;
      details: string;
    };
    requestTitle: string;
    transactionID: string;
    requestReceivedTime: string;
    responseSentTime: string;
    sessionID: string;
    userName: string;
    branchName: string;
    branchgroupName: string;
    webName: string;
    flightAPINode: string;
    transactions: {
      errorCode: string;
      title: string;
      success: boolean;
      errorMessage: string;
      source: string;
      startTime: string;
      endTime: string;
      details: string;
    }[];
    environment: string;
  };
}


export interface AllotmentSegmentInfoModel {
  /** Two Letter airline code */
  airline: string | undefined;
  /** Three letter arrival city/airport code */
  arrival: string | undefined;
  /** Segment arrival info */
  arrivalDateTime: Date | undefined;
  /** Booking class of segment if provided by GDS/Airline */
  bookingClass: string | undefined;
  /** The cabin class pertaining to the booking class and the requested airline of the segment */
  cabinClass: CabinClassInput | undefined;
  dayIndicator: number | undefined;
  /** Three letter departure city/airport code */
  departure: string | undefined;
  /** Segment departure info */
  departureDateTime: Date | undefined;
  direction: DirectionEnumModel | undefined;
  /** e.g BA 001, LH 5220 */
  flightNumber: number | undefined;
  isPointOfTurnaroundSegment: boolean | undefined;
  stay: number | undefined;
}

export enum DirectionEnumModel {
  Undefined = 0,
  Outbound = 1,
  Inbound = 2,
}

export interface AllotmentTypeModel {
  none: boolean;
  groupbookingOnline: boolean;
  groupbookingOffline: boolean;
  bookingclass: boolean;
  virtual: boolean;
  negospace: boolean;
  prospective: boolean;
  groupbookingOnlinePassive: boolean;
  groupbookingOnlineActive: boolean;
  all: boolean;
}

export interface AllotmentAccountModel {
  database: string | undefined;
  password: string | undefined;
  user: string | undefined;
}

export interface GetAllotmentInfoRequestModel {
  /** The account to be used. If empty the user stored information will be used. */
  account: AllotmentAccountModel | undefined;
  /** Two letter airline code */
  airline: string | undefined;
  /** Allotment ID as defined in the allotment database */
  allotmentID: number | undefined;
  /** Request object to activate Allotment handling. If this parameter is set the application searches in an external Allotment database in addition to the search in the GDS. 
Note: This is an additional module, which has to be installed and activated on your system.
Any combination of the possible values are allowed:
        •	None
        •	GroupbookingOnline
        •	GroupbookingOffline
        •	Bookingclass
        •	Virtual
        •	Negospace
        •	Prospective
        •	All */
  allotmentType: AllotmentTypeModel | undefined;
  /** Three letter arrival airport/city code
   */
  arrival: string | undefined;
  /** Earliest arrival date in date range for requested allotment details */
  arrivalFromDate: Date | undefined;
  /** Latest arr date in date range for requested allotment details */
  arrivalUntilDate: Date | undefined;
  /** Booking class of allotment */
  bookingclass: string | undefined;
  /** Returns the corresponding cabin class: Economy, Business, First Or PremiumEconomy. */
  cabinclass: CabinClassInput | undefined;
  /** Three letter airport/city code */
  departure: string | undefined;
  /** Earliest dep date in date range for requested allotment details */
  departureFromDate: Date | undefined;
  /** Latest dep date in date range for requested allotment details */
  departureUntilDate: Date | undefined;
  /** The GDS or Airline (depending on allotment type) PNR/BookingRef/Filekey */
  filekey: string | undefined;
  /** Flight number in Allotment – to target specific flight numbers */
  flightNumber: string | undefined;
  /** Flag to return Inactive Allotments */
  includeInactiveAllotments: boolean | undefined;
  /** Max number of results */
  maximumResults: number | undefined;
  /** The identifier for an used program. */
  programNumber: string | undefined;
  /** Flag to retrieve bookings. */
  retrieveBookings: boolean | undefined;
  ruleMatchCode: string | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}


export interface FareRulesResponse {
  result: {
    validationResult: {
      isValid: boolean;
      errorSummary: string[];
      properyErrors: Record<string, unknown>;
    };
    fareRulesResult: {
      dateOfBooking: string;
      rules: Array<{
        ruleHeader: string;
        ruleLines: string[];
      }>;
    };
  };
  responseMetaData: BaseApiResponseMetaData
}


export interface BookingCommunicationResponse {
  result: {
    validationResult: ValidationResult;
    ioResponsesResult: IoResponse[];
  };
  responseMetaData: BaseApiResponseMetaData;
}

export interface ValidationResult {
  isValid: boolean;
  errorSummary: string[];
  properyErrors: Record<string, unknown>;
}

export interface IoResponse {
  bookingSource: string;
  exception: string | null;
  extensions: unknown | null;
  request: string;
  requestType: string;
  response: string;
  version: number;
}

export interface ErrorReason {
  errorCode: string;
  title: string;
  success: boolean;
  errorMessage: string;
  source: string;
  startTime: string;
  endTime: string;
  details: string;
}

export interface Transaction {
  errorCode: string;
  title: string;
  success: boolean;
  errorMessage: string;
  source: string;
  startTime: string;
  endTime: string;
  details: string;
}


export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}




function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  console.error("🚨 throwException triggered:", {
    message,
    status,
    response,
    headers,
    result,
  });

  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

